// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-05T17:25:40.204Z
// Property: Cottages at Stonesthrow (ID: 6767906449166559)
// Collections: 14 amenities, 6 floorplans (live), 18 photos, 80 POIs, 3 reviews, 5 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449166559",
  "property_external_id": "3x01sde",
  "property_zillow_url": "https://www.zillow.com/apartments/meridian-id/stonesthrow/Cj6npS/",
  "property_apartments_url": "https://www.apartments.com/cottages-at-stonesthrow-meridian-id/3x01sde/",
  "property_google_business_url": "https://www.google.com/maps/place/Stonesthrow+Townhomes+%26+Cottages/@43.6168282,-116.3418195,3047m/data=!3m1!1e3!4m6!3m5!1s0x54ae55f9a79aa05b:0x8d5b5611c67e984e!8m2!3d43.6166011!4d-116.3422118!16s%2Fg%2F11ffg9t2m1!5m1!1e1?entry=ttu&g_ep=EgoyMDI1MDkyNC4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": "39895424274",
  "property_crm_software": null,
  "property_pm_software": "AIM",
  "property_pm_info": "596ST2",
  "property_status": null,
  "property_slug": "cottages-at-stonesthrow",
  "property_name": "Cottages at Stonesthrow",
  "property_website_url": "https://www.cottagesatstonesthrow.com/",
  "property_domain": "https://www.cottagesatstonesthrow.com/",
  "property_address": "4195 East Florence Drive",
  "property_full_address": "4195 E Florence Dr, Meridian, ID 83642, USA",
  "property_address_1": "4195 East Florence Drive",
  "property_address_2": null,
  "property_address_city": "Meridian",
  "property_address_state": "ID",
  "property_address_zip_full": null,
  "property_address_zip": "83642",
  "property_address_country": "US",
  "property_address_county": "Ada County",
  "property_neighborhood_address": "West Boise",
  "property_address_latitude": "43.6165745",
  "property_address_longitude": "-116.3422104",
  "property_email": null,
  "property_phone": "(208) 609-3535",
  "property_call_tracking_phone": null,
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Cottages at Stonesthrow in Meridian, ID, spacious two- and three-bedroom apartments elevate your living experience. Enjoy vaulted ceilings, hardwood floors, and a welcoming clubhouse. With added perks like a dog park and convenient door-to-door trash pickup, this is more than a residence—it’s a vibrant community waiting for you!",
  "property_long_description": "**Welcome to Cottages at Stonesthrow – Your Dream Home Awaits!**\n\nDiscover upscale living in the heart of Meridian, ID, at Cottages at Stonesthrow. Our thoughtfully designed apartment community offers two and three-bedroom floor plans, perfect for families, professionals, or anyone seeking a spacious new home. Each apartment features a modern loft layout, equipped with stunning hardwood floors and high ceilings that create an airy atmosphere.\n\nDesigned for comfort and convenience, our homes boast large bedrooms and walk-in closets, ensuring you have plenty of space to relax and recharge. Cook and entertain in style in your island kitchen complete with a pantry, ice maker, and eat-in options that cater to your culinary adventures. Additional perks such as our den area and linen closet enhance your living experience, making organization effortless.\n\nOur community amenities are tailored to enrich your lifestyle. Enjoy our inviting clubhouse, perfect for social gatherings and events. Outdoor enthusiasts will appreciate the on-site dog park, and the added convenience of door-to-door trash pickup and recycling services makes day-to-day living smooth and hassle-free. \n\nConnect with neighbors and enjoy the serene views from your porch or deck, making afternoons spent at home delightful. With a dedicated renters insurance program and plenty of storage space available, you can rest easy knowing Cottages at Stonesthrow has you covered.\n\nDon’t miss out on your chance to be part of this vibrant community. **Find your new home today—browse our availability or schedule a tour to visit Cottages at Stonesthrow in Meridian, ID!**",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
  "property_featured_image_media": {
    "alt_text": "Stone Throw community sign with windmill and clubhouse in background.",
    "public_id": "019d02cf-0015-745f-8329-5657ae2904ba",
    "storage_key": "property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
    "width": 1037,
    "height": 691
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "60",
  "property_year_built": "2018",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "98.33333333333333",
  "property_admin_fee": "299",
  "property_application_fee": "34",
  "property_fees_deposit_info": "Deposit: $400",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "299",
  "property_pet_deposit": "150",
  "property_monthly_pet_rent": "40",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Up to 2 pets per unit (cats and dogs) under 100 lb, with breed restrictions and minimum age of 1 year.",
  "property_pet_policy_description": "We allow up to 2 pets per unit (cats and dogs) under 100 lb, with breed restrictions and minimum age of 1 year. First pet: $299 non‑refundable fee + $150 refundable deposit. Second pet: $299 non‑refundable fee + $150 refundable deposit. Pet rent: $40 per pet per month.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://cottagesatstonesthrow.goprisma.com/auth/login",
  "property_apply_now_url": "https://myrentalapplication.com/index/amccottagesatstonesthrow",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02ce-9af4-757c-ab80-b2b7e32cbe66.webp",
  "property_primary_logo_media": {
    "alt_text": "The Cottages at Stonesthrow logo",
    "public_id": "019d02ce-9af4-757c-ab80-b2b7e32cbe66",
    "storage_key": "property/6767906449166559/019d02ce-9af4-757c-ab80-b2b7e32cbe66.webp",
    "width": 457,
    "height": 211
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02d0-b80e-73ef-b45a-66ff703adf7a.webp",
  "property_secondary_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02d0-b80e-73ef-b45a-66ff703adf7a",
    "storage_key": "property/6767906449166559/019d02d0-b80e-73ef-b45a-66ff703adf7a.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02d0-c589-762c-b829-f72d5c8db5f6.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Cottages at Stonesthrow logo.",
    "public_id": "019d02d0-c589-762c-b829-f72d5c8db5f6",
    "storage_key": "property/6767906449166559/019d02d0-c589-762c-b829-f72d5c8db5f6.webp",
    "width": 457,
    "height": 211
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02d0-cf8e-75c4-aebe-28a4e6e165b6.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Cottages at Stonesthrow logo",
    "public_id": "019d02d0-cf8e-75c4-aebe-28a4e6e165b6",
    "storage_key": "property/6767906449166559/019d02d0-cf8e-75c4-aebe-28a4e6e165b6.webp",
    "width": 457,
    "height": 211
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#38505a",
  "property_secondary_color": "#9b7a68",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": "#f9f9f9",
  "property_bedrooms_range": "2 - 3",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "2 - 2.5",
  "property_bathrooms_min": "2",
  "property_bathrooms_max": "2.5",
  "property_sqft_range": "1007 - 1419",
  "property_sqft_min": "1007",
  "property_sqft_max": "1419",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": 1,
  "property_facebook_url": "https://www.facebook.com/stonesthrowresidences",
  "property_instagram_url": "https://www.instagram.com/stonesthrow_townhomes/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJW6Cap_lVrlQRTph-xhFWW40",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/stonesthrow-townhomes-meridian",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Cottages at Stonesthrow",
  "property_home_romance_title": "Embrace a Life You’ll Love in Our Vibrant Community",
  "property_home_amenities_blurb": "Welcome to Cottages at Stonesthrow in Meridian, ID, where spacious two and three-bedroom apartments combine comfort with style. Enjoy high ceilings, hardwood floors, and a modern island kitchen, alongside our inviting clubhouse, dog park, and convenient door-to-door trash pickup. Experience exceptional living and make it your home!",
  "property_home_floorplans_blurb": "At Cottages at Stonesthrow in Meridian, ID, our thoughtfully designed two and three-bedroom apartments offer the perfect blend of comfort and style. Picture your next chapter in a welcoming community tailored to your lifestyle. Browse our available apartment homes and find the ideal floor plan that suits you!",
  "property_home_gallery_blurb": "Welcome to the Cottages at Stonesthrow in Meridian, ID, where modern living meets comfort. Choose from spacious two- and three-bedroom floor plans featuring hardwood floors, high ceilings, and luxurious island kitchens. Picture yourself enjoying our inviting clubhouse, dog park, and outdoor deck—your dream apartment lifestyle awaits!",
  "property_home_neighborhood_blurb": "At Cottages at Stonesthrow in Meridian, ID, enjoy comfortable living with spacious two and three-bedroom floor plans. Step outside to vibrant parks, top schools, and recreational hotspots like the Roaring Springs Water Park and Village Cinema. Uncover the ideal blend of serenity and convenience right at your doorstep.",
  "property_home_reviews_blurb": "Nestled in the heart of Meridian, ID, Cottages at Stonesthrow shines with impeccable management and a friendly maintenance team. Residents rave, \"They’re friendly, funny, and just super swell people all around,\" making it a delightful place to call home. Experience community living where every detail matters—your perfect haven awaits!",
  "property_neighborhood_blurb": "At Cottages at Stonesthrow in Meridian, ID, vibrant community life awaits! Nestled among parks, schools, and entertainment venues, our spacious two- and three-bedroom apartments offer easy access to The Village at Meridian, Idaho Botanical Garden, and the lively Wahooz Family Fun Zone. Embrace a lifestyle where adventure thrives!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Cottages at Stonesthrow in Meridian, ID, comfort meets style with spacious two and three-bedroom apartments. Enjoy high ceilings, hardwood floors, and island kitchens while indulging in our dog park and clubhouse. With generous storage options and unique loft layouts, your ideal lifestyle awaits—experience it today!",
  "property_applynow_blurb": "Welcome to Cottages at Stonesthrow in Meridian, ID, where spacious two and three-bedroom layouts meet vibrant community amenities. Enjoy high ceilings, island kitchens, and dog parks, all designed for modern living. With storage solutions and a welcoming clubhouse, your new home awaits. Apply now and lease online today!",
  "property_contactus_blurb": "At Cottages at Stonesthrow in Meridian, ID, our thoughtfully designed two and three-bedroom apartments offer the perfect blend of comfort and style. Let our welcoming community be your new retreat. Have questions? Contact our leasing team today and find the home you've always wanted!",
  "property_faqs_blurb": "At Cottages at Stonesthrow in Meridian, ID, our thoughtfully designed two and three-bedroom floor plans cater to your lifestyle. Seeking answers? Visit our FAQs page for insights on community living, amenities, and more—everything you need to make the Cottages your next home sweet home!",
  "property_floorplans_blurb": "At Cottages at Stonesthrow in Meridian, ID, we offer thoughtfully designed two and three-bedroom floor plans that cater to your unique lifestyle. Each spacious layout shines with modern finishes and inviting interiors. Browse our available apartment homes today and find the perfect floor plan that suits your needs!",
  "property_gallery_blurb": "At Cottages at Stonesthrow in Meridian, ID, your next home awaits in stylish two and three-bedroom layouts. Revel in high ceilings, gourmet island kitchens, and spacious walk-in closets. Imagine cozy evenings on the porch or playing fetch at the dog park—your dream lifestyle starts here! Picture yourself living here!",
  "property_interactivemap_blurb": "At Cottages at Stonesthrow in Meridian, ID, find your perfect retreat. Choose between spacious two and three-bedroom floor plans featuring hardwood floors, island kitchens, and expansive walk-in closets. Enjoy exclusive amenities like a clubhouse, dog park, and door-to-door trash pickup. Check our interactive community map to find your new home!",
  "property_pets_blurb": "Welcome to Cottages at Stonesthrow, where your furry friends find a home as cozy as yours. Nestled in Meridian, ID, our community embraces pet lovers—with space for two pets under 100 lbs. Experience comfortable living alongside your pets, complete with tailored amenities just for them. Live the life you both deserve!",
  "property_referafriend_blurb": "At Cottages at Stonesthrow in Meridian, ID, you’ll find the perfect home for you and your friends, whether it’s our spacious two-bedroom or three-bedroom floor plans. Great friends make great neighbors – refer a friend to our vibrant community today and enjoy life together in comfort!",
  "property_residentaccess_blurb": "At Cottages at Stonesthrow in Meridian, ID, our thoughtfully designed two and three-bedroom floor plans offer the perfect blend of comfort and style. Ready to manage your living experience? Access your resident portal to easily pay rent, schedule maintenance, and explore everything our community has to offer!",
  "property_reviews_blurb": "At Cottages at Stonesthrow in Meridian, ID, our residents rave about the exceptional living experience. One resident notes, \"The management are friendly and go out of their way to help,\" reflecting the community's commitment to service. Join us and experience the charm of our beautifully maintained grounds!",
  "property_created_at": "1760456976477",
  "property_scheduletour_blurb": "At Cottages at Stonesthrow in Meridian, ID, our inviting two and three-bedroom floor plans offer the perfect blend of comfort and style. Ready to envision your new home? Schedule a tour today and hear firsthand from our residents about why they love calling our community home!",
  "property_thankyou_blurb": "Thank you for reaching out to us at Cottages at Stonesthrow in Meridian, ID! With spacious two and three-bedroom floor plans tailored for your comfort, your dream home awaits. Our team will be in touch soon to help you take the next step toward your ideal living space!",
  "property_virtualtours_blurb": "At Cottages at Stonesthrow in Meridian, ID, our inviting two and three-bedroom apartments offer a unique blend of comfort and style. Experience the warmth of home with spacious floor plans tailored to your lifestyle. Ready to see for yourself? Take a virtual tour of our vibrant community today!",
  "property_copyright": "2025 All Rights Reserved. Cottages at Stonesthrow",
  "property_seo_title_home": "Cottages at Stonesthrow |  Apartments in Meridian, ID",
  "property_seo_description_home": "Experience modern living at Cottages at Stonesthrow in Meridian, ID. Enjoy spacious layouts, upscale amenities, and a vibrant community. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Meridian, ID Apartments for Rent",
  "property_seo_description_floorplans": "Find your dream home at Cottages at Stonesthrow! Browse our spacious 2 & 3-bedroom floor plans in Meridian, ID, and elevate your living experience today!",
  "property_seo_title_amenities": "Amenities | Meridian, ID Apartments for Rent",
  "property_seo_description_amenities": "Discover the charm of Cottages at Stonesthrow in Meridian, ID! Enjoy spacious layouts, inviting amenities, and a lifestyle-focused community.",
  "property_seo_title_gallery": "Gallery | Apartments in Meridian, ID",
  "property_seo_description_gallery": "Experience vibrant living at Cottages at Stonesthrow, Meridian, ID, with spacious layouts, modern amenities, and serene outdoor spaces!",
  "property_seo_title_virtualtours": "Virtual Tours | Cottages at Stonesthrow Apartments",
  "property_seo_description_virtualtours": "Step inside Cottages at Stonesthrow in Meridian, ID! Take a virtual tour of our spacious two and three-bedroom apartments and envision your new home today.",
  "property_seo_title_interactivemap": "Interactive Map | Cottages at Stonesthrow Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Cottages at Stonesthrow, Meridian, ID! Explore spacious two and three-bedroom layouts with great amenities!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Meridian, ID",
  "property_seo_description_neighborhood": "Explore the charm of Meridian at Cottages at Stonesthrow, where local favorites and hidden gems await near our two and three-bedroom homes!",
  "property_seo_title_contact": "Contact Us | Cottages at Stonesthrow",
  "property_seo_description_contact": "Connect with the Cottages at Stonesthrow in Meridian, ID! Inquire about our spacious two and three-bedroom floor plans. Your new home awaits—reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Meridian, ID",
  "property_seo_description_faqs": "Discover Cottages at Stonesthrow in Meridian, ID. Inquire about amenities and floor plans—your new home awaits!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Meridian, ID",
  "property_seo_description_reviews": "At Cottages at Stonesthrow, residents enjoy spacious layouts and premium amenities. Hear their stories and see why they love calling Meridian home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Meridian, ID",
  "property_seo_description_applynow": "Discover Cottages at Stonesthrow: stylish 2 & 3-bedroom homes with premium amenities. Lease online and start your new chapter today!",
  "property_seo_title_residentaccess": "Resident Access | Cottages at Stonesthrow",
  "property_seo_description_residentaccess": "Welcome to Cottages at Stonesthrow! Log in to your portal for easy rent payments and maintenance requests for seamless living in Meridian, ID.",
  "property_seo_title_referafriend": "Refer A Friend | Cottages at Stonesthrow",
  "property_seo_description_referafriend": "Refer a friend to Cottages at Stonesthrow in Meridian, ID! Great friends make great neighbors—share the joy of community living today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Cottages at Stonesthrow",
  "property_seo_description_scheduletour": "Experience the charm of Cottages at Stonesthrow in Meridian, ID. Schedule your tour today and envision your new life in our vibrant community!",
  "property_seo_title_privacy": "Privacy Policy | Cottages at Stonesthrow",
  "property_seo_description_privacy": "At Cottages at Stonesthrow, your privacy matters. Uncover how we safeguard your information in our detailed privacy policy. Feel secure in Meridian, ID.",
  "property_seo_title_accessibility": "Website Accessibility | Cottages at Stonesthrow",
  "property_seo_description_accessibility": "Cottages at Stonesthrow in Meridian, ID, champions digital inclusion. Join us to create a welcoming online community for all!",
  "property_seo_title_sitemap": "Sitemap | Cottages at Stonesthrow",
  "property_seo_description_sitemap": "Uncover every corner of Cottages at Stonesthrow in Meridian, ID. Navigate our sitemap to find your perfect apartment and community amenities today!",
  "property_seo_title_thankyou": "Thank You | Cottages at Stonesthrow",
  "property_seo_description_thankyou": "Thank you for reaching out! Your journey to comfortable living at Cottages at Stonesthrow in Meridian, ID, is just beginning. Stay tuned for our team's call!",
  "property_seo_title_pets": "Pet Policy | Apartments in Meridian, ID",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1790781401348",
  "amenities": [
    {
      "id": "ec_e54060b2da7a270751b5e7a1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "generator",
      "external_id": "false",
      "title": "Convenient Location",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8c298ee17f734a3a4e39e28f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "generator",
      "external_id": "false",
      "title": "Professional Landscaping",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_10014e5a7195dd48a07f1475",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "generator",
      "external_id": "false",
      "title": "Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3978e77648af1e8deade9a83",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "generator",
      "external_id": "false",
      "title": "Gazebo Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f0c3149803546ab4ca5180d4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "generator",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5f011ce19cdb6b4ba3a990d2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "generator",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c983b54fe8e15e6dbc6d4e59",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "generator",
      "external_id": "false",
      "title": "Outdoor Fire Pit with Lounge Seating",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b9aec3224fb13cee8cfe53cc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "generator",
      "external_id": "false",
      "title": "Volleyball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4c7b0d9529c43e808dde02b0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "generator",
      "external_id": "false",
      "title": "Walk In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d4d13e1e0fe8e32ec8d45e4c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "generator",
      "external_id": "false",
      "title": "Large Bedrooms",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b51c38cde71cf31e1c1d1e43",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "generator",
      "external_id": "false",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_56b0410db4938d73c160c45f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "generator",
      "external_id": "false",
      "title": "Fully Equipped Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_146fe6fb412824fb2f66575a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "generator",
      "external_id": "false",
      "title": "Walk in Closet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_67994be64e976946ce778b83",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "generator",
      "external_id": "false",
      "title": "Hardwood Floors*",
      "amount": "false",
      "description": "Only in select units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_524b392d-93a4-490e-87f5-d267982472f0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02d0-66c2-75b4-8c4c-bb887788184b.webp",
      "image_media": {
        "alt_text": "Monument sign for The Cottages with buildings in the background.",
        "public_id": "019d02d0-66c2-75b4-8c4c-bb887788184b",
        "storage_key": "property/6767906449166559/019d02d0-66c2-75b4-8c4c-bb887788184b.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Welcome to The Cottages, featuring charming exteriors and lush landscaping.",
      "link": "",
      "alt_text": "Monument sign for The Cottages with buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7014d7fe-53b6-4da3-8d37-03bd5dfba910",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02d0-65fd-7601-9870-8eb8883ab00d.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and a clubhouse in the background.",
        "public_id": "019d02d0-65fd-7601-9870-8eb8883ab00d",
        "storage_key": "property/6767906449166559/019d02d0-65fd-7601-9870-8eb8883ab00d.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor pool, complete with comfortable lounge chairs and a modern clubhouse for relaxation.",
      "link": "",
      "alt_text": "Outdoor swimming pool area with lounge chairs and a clubhouse in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e585bce0-47bd-4e4a-8ec2-fa1cf442b01e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02d0-5107-76e1-baff-428801e8835a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and dark wood cabinets.",
        "public_id": "019d02d0-5107-76e1-baff-428801e8835a",
        "storage_key": "property/6767906449166559/019d02d0-5107-76e1-baff-428801e8835a.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, granite countertops, ample cabinet space, and an island with a sink. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and dark wood cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f23f6ae7-9f28-4f86-9149-32b39e7fe328",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02d0-541a-7142-9208-593c5154868a.webp",
      "image_media": {
        "alt_text": "Modern living room with a gray sectional sofa, orange and cow print pillows, and stairs.",
        "public_id": "019d02d0-541a-7142-9208-593c5154868a",
        "storage_key": "property/6767906449166559/019d02d0-541a-7142-9208-593c5154868a.webp",
        "width": 640,
        "height": 427
      },
      "title": "Apartment",
      "description": "Stylish living area featuring a comfortable sectional sofa, decorative pillows, and carpeted stairs leading to the upper level.",
      "link": "",
      "alt_text": "Modern living room with a gray sectional sofa, orange and cow print pillows, and stairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_db930e5f-c2e4-4015-8234-940757589d33",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
      "image_media": {
        "alt_text": "Stone Throw community sign with windmill and clubhouse in background.",
        "public_id": "019d02cf-0015-745f-8329-5657ae2904ba",
        "storage_key": "property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
        "width": 1037,
        "height": 691
      },
      "title": "Community",
      "description": "Welcome to Stone Throw, a beautiful community featuring a clubhouse with a windmill and lush landscaping.",
      "link": "",
      "alt_text": "Stone Throw community sign with windmill and clubhouse in background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dce89d01-3cf7-4132-bd60-494e92175a34",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02ce-ef61-721c-8db9-c86b5a7aaaf8.webp",
      "image_media": {
        "alt_text": "Exterior of a modern townhouse with a white garage door and beige siding.",
        "public_id": "019d02ce-ef61-721c-8db9-c86b5a7aaaf8",
        "storage_key": "property/6767906449166559/019d02ce-ef61-721c-8db9-c86b5a7aaaf8.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Charming townhouse exterior featuring a spacious garage and contemporary design, nestled in a vibrant community.",
      "link": "",
      "alt_text": "Exterior of a modern townhouse with a white garage door and beige siding.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_792eb817-edee-49c8-bfd7-f3075afcb154",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02ce-ea72-7370-bc54-ef9a1c994611.webp",
      "image_media": {
        "alt_text": "Exterior of a townhouse with brown siding, light blue door, and white picket fence.",
        "public_id": "019d02ce-ea72-7370-bc54-ef9a1c994611",
        "storage_key": "property/6767906449166559/019d02ce-ea72-7370-bc54-ef9a1c994611.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Charming exterior of a townhouse featuring warm brown siding, a welcoming light blue door, and a quaint white picket fence, creating an inviting curb appeal.",
      "link": "",
      "alt_text": "Exterior of a townhouse with brown siding, light blue door, and white picket fence.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ea4fd978-95bb-4b98-8abf-0139fb18c58c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02ce-e493-707d-8c73-a9ae5db1fdc1.webp",
      "image_media": {
        "alt_text": "Exterior of a tan house with a light blue front door and white picket fence.",
        "public_id": "019d02ce-e493-707d-8c73-a9ae5db1fdc1",
        "storage_key": "property/6767906449166559/019d02ce-e493-707d-8c73-a9ae5db1fdc1.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Charming exterior of a tan house featuring a welcoming light blue front door, clean white picket fence, and well-maintained landscaping. Perfect for a cozy, inviting home.",
      "link": "",
      "alt_text": "Exterior of a tan house with a light blue front door and white picket fence.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_08c4075a-b91d-4953-b070-460dda63eb7e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02ce-da14-71cc-9d70-6df4e9e03cca.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with stone fireplace and seating near a pool and pergola.",
        "public_id": "019d02ce-da14-71cc-9d70-6df4e9e03cca",
        "storage_key": "property/6767906449166559/019d02ce-da14-71cc-9d70-6df4e9e03cca.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Relax and unwind in the outdoor lounge area, complete with a cozy stone fireplace, comfortable seating, and a shimmering pool, perfect for enjoying the beautiful weather.",
      "link": "",
      "alt_text": "Outdoor lounge area with stone fireplace and seating near a pool and pergola.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b7fa6b13-3181-4909-8771-6d4030fe60ac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02ce-d1b5-729a-914c-2dc8f1eb3f8e.webp",
      "image_media": {
        "alt_text": "Outdoor living space with a stone fireplace, TV, seating, and bar stools.",
        "public_id": "019d02ce-d1b5-729a-914c-2dc8f1eb3f8e",
        "storage_key": "property/6767906449166559/019d02ce-d1b5-729a-914c-2dc8f1eb3f8e.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy the outdoors with this inviting community living space, featuring a cozy stone fireplace, comfortable seating, and a convenient bar area perfect for entertaining.",
      "link": "",
      "alt_text": "Outdoor living space with a stone fireplace, TV, seating, and bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3e430602-6a2c-4c88-bea3-f3d7fe80aada",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02ce-cef0-70de-a7fd-0e7204c39559.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a shaded dining area with tables and chairs.",
        "public_id": "019d02ce-cef0-70de-a7fd-0e7204c39559",
        "storage_key": "property/6767906449166559/019d02ce-cef0-70de-a7fd-0e7204c39559.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, perfect for relaxing or socializing. Adjacent shaded patio with dining sets offers a great spot for al fresco meals.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a shaded dining area with tables and chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_20ab4a43-9224-4dae-a013-eef6c64e9ebb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02ce-c370-728b-bbde-10ae0c704588.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio equipment, including treadmills and stationary bikes.",
        "public_id": "019d02ce-c370-728b-bbde-10ae0c704588",
        "storage_key": "property/6767906449166559/019d02ce-c370-728b-bbde-10ae0c704588.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center offers a variety of cardio machines for a great workout.",
      "link": "",
      "alt_text": "Fitness center with cardio equipment, including treadmills and stationary bikes.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_550242c7-d9d9-4784-999a-181cafeef8e4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02ce-bc01-77fd-b346-172a7c49367c.webp",
      "image_media": {
        "alt_text": "Weight benches and a multi-station weight machine in a spacious gym.",
        "public_id": "019d02ce-bc01-77fd-b346-172a7c49367c",
        "storage_key": "property/6767906449166559/019d02ce-bc01-77fd-b346-172a7c49367c.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Workout in our state-of-the-art fitness center, featuring weight benches and a comprehensive weight machine for a full-body workout.",
      "link": "",
      "alt_text": "Weight benches and a multi-station weight machine in a spacious gym.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4ca51116-30e1-4a98-afdd-b7c6b1ba043c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02ce-b938-7420-8e05-2bda205a09bd.webp",
      "image_media": {
        "alt_text": "Modern apartment gym with treadmills, weight racks, and large mirrors.",
        "public_id": "019d02ce-b938-7420-8e05-2bda205a09bd",
        "storage_key": "property/6767906449166559/019d02ce-b938-7420-8e05-2bda205a09bd.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio machines, free weights, and a spacious workout area, perfect for maintaining your active lifestyle.",
      "link": "",
      "alt_text": "Modern apartment gym with treadmills, weight racks, and large mirrors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e3f9fb81-c321-4abd-bbfd-6e912be22380",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02ce-b6ec-763b-b542-edf615f69beb.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
        "public_id": "019d02ce-b6ec-763b-b542-edf615f69beb",
        "storage_key": "property/6767906449166559/019d02ce-b6ec-763b-b542-edf615f69beb.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, granite countertops, a large island, and ample cabinet space.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d26aeed0-024c-4e2b-ad22-8fef500dab2b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02ce-b083-7119-8936-04d8504d9dea.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, dark cabinets, granite countertops, and a dining table.",
        "public_id": "019d02ce-b083-7119-8936-04d8504d9dea",
        "storage_key": "property/6767906449166559/019d02ce-b083-7119-8936-04d8504d9dea.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Discover this stylish kitchen featuring stainless steel appliances, ample cabinet space, and a cozy dining area, perfect for everyday living.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, dark cabinets, granite countertops, and a dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7f9504b4-93df-43d2-ace5-95e2b2f64b85",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02ce-af55-71f0-b0e4-173c23a74ac1.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and dark wood cabinets.",
        "public_id": "019d02ce-af55-71f0-b0e4-173c23a74ac1",
        "storage_key": "property/6767906449166559/019d02ce-af55-71f0-b0e4-173c23a74ac1.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, granite countertops, and ample cabinet storage. Perfect for home chefs and entertainers.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and dark wood cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6d309a66-3612-4c3c-9340-5855fbc9cc35",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02ce-aea1-758e-9b47-a8ec6b1d29f8.webp",
      "image_media": {
        "alt_text": "Modern leasing office reception desk with two chairs and a bar area with stools.",
        "public_id": "019d02ce-aea1-758e-9b47-a8ec6b1d29f8",
        "storage_key": "property/6767906449166559/019d02ce-aea1-758e-9b47-a8ec6b1d29f8.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Welcome to our modern leasing office, featuring a stylish reception desk, comfortable seating, and a contemporary bar area for guests.",
      "link": "",
      "alt_text": "Modern leasing office reception desk with two chairs and a bar area with stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_187f2882-7396-4cdc-a69a-a005646dee2d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Starbucks",
      "poi_type": "Restaurants",
      "poi_address": "3120 E Florence St, Meridian, ID 83642, USA",
      "poi_short_description": "Seattle-based coffeehouse chain known for its signature roasts, light bites and WiFi availability.",
      "poi_long_description": "Seattle-based coffeehouse chain known for its signature roasts, light bites and WiFi availability.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-102c-70ea-bddf-7972f418645f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-102c-70ea-bddf-7972f418645f",
        "storage_key": "property/6767906449166559/019d02cf-102c-70ea-bddf-7972f418645f.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "https://www.starbucks.com/store-locator/store/16881/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17492204942858430857&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "starbucks",
      "poi_latitude": "43.61747",
      "poi_longitude": "-116.35515",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 208-846-8483",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-a60a-76ef-8ee8-e4c49c30baa7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-a60a-76ef-8ee8-e4c49c30baa7",
        "storage_key": "property/6767906449166559/019d02cf-a60a-76ef-8ee8-e4c49c30baa7.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJefycJxdUrlQRialoxbfLwPI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_5ca58440-d13f-455f-9bdf-8f94bf7be717",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Wendy's",
      "poi_type": "Restaurants",
      "poi_address": "3140 E Florence St, Meridian, ID 83642, USA",
      "poi_short_description": "Fast-food burger chain serving sides such as chili & baked potatoes.",
      "poi_long_description": "Fast-food burger chain serving sides such as chili & baked potatoes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-0f87-74af-a0ec-253fa1e6ad24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-0f87-74af-a0ec-253fa1e6ad24",
        "storage_key": "property/6767906449166559/019d02cf-0f87-74af-a0ec-253fa1e6ad24.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://locations.wendys.com/united-states/id/meridian/3140-e-florence?utm_source=Yext&utm_medium=Google_My_Business&utm_campaign=Local_Search&utm_content=EN_US",
      "poi_directions_map_url": "https://maps.google.com/?cid=6839260943926886064&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wendys",
      "poi_latitude": "43.6170857",
      "poi_longitude": "-116.3550968",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 208-884-5303",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-a60c-71a6-897a-37f961c0f1ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-a60c-71a6-897a-37f961c0f1ce",
        "storage_key": "property/6767906449166559/019d02cf-a60c-71a6-897a-37f961c0f1ce.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJmdn3LhdUrlQRsP72sJfv6V4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_0eae24e4-47b7-4f35-8700-822f763699d1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "IHOP",
      "poi_type": "Restaurants",
      "poi_address": "3525 E Fairview Ave, Meridian, ID 83642, USA",
      "poi_short_description": "Long-standing chain serving a wide variety of pancakes & other American breakfast & diner fare.",
      "poi_long_description": "Long-standing chain serving a wide variety of pancakes & other American breakfast & diner fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-1010-70cf-8c9d-7971074f7f66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-1010-70cf-8c9d-7971074f7f66",
        "storage_key": "property/6767906449166559/019d02cf-1010-70cf-8c9d-7971074f7f66.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "https://restaurants.ihop.com/en-us/id/meridian/breakfast-3525-e-fairview-ave-1746?utm_source=google&utm_medium=organic&utm_campaign=google_my_business&utm_term=1746&utm_content=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=16863775474202570179&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ihop",
      "poi_latitude": "43.6191283",
      "poi_longitude": "-116.350962",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 208-888-1216",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-a60c-71a6-897a-37f961c0f1ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-a60c-71a6-897a-37f961c0f1ce",
        "storage_key": "property/6767906449166559/019d02cf-a60c-71a6-897a-37f961c0f1ce.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJv6jJiD1UrlQRw-3JF3IqCOo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_79d86aaf-1d8c-474d-a089-61a96b908dc3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Applebee's Grill + Bar",
      "poi_type": "Restaurants",
      "poi_address": "1460 N Eagle Rd, Meridian, ID 83642, USA",
      "poi_short_description": "Full-service chain bar & grill providing hearty American eats in an informal setting.",
      "poi_long_description": "Full-service chain bar & grill providing hearty American eats in an informal setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-100c-71cb-96a0-1858733528e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-100c-71cb-96a0-1858733528e0",
        "storage_key": "property/6767906449166559/019d02cf-100c-71cb-96a0-1858733528e0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://restaurants.applebees.com/en-us/id/meridian/1460-n.-eagle-road-84089?utm_source=google&utm_medium=organic&utm_campaign=google_my_business&utm_term=84089&utm_content=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=16739916433148784933&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "applebees-grill--bar",
      "poi_latitude": "43.61808389999999",
      "poi_longitude": "-116.3538815",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 208-855-0343",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-a60c-71a6-897a-37f961c0f1ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-a60c-71a6-897a-37f961c0f1ce",
        "storage_key": "property/6767906449166559/019d02cf-a60c-71a6-897a-37f961c0f1ce.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJP-2I_BZUrlQRJbGO100hUOg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_157e63b6-8b98-489b-bfcf-9276b6694cf1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Jakers Bar and Grill",
      "poi_type": "Restaurants",
      "poi_address": "3268 E Pine Ave, Meridian, ID 83642, USA",
      "poi_short_description": "Upscale-casual bar & grill offering inventive American dishes, plus salads & cocktails.",
      "poi_long_description": "Upscale-casual bar & grill offering inventive American dishes, plus salads & cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-1776-7794-b9b6-53da6409411f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-1776-7794-b9b6-53da6409411f",
        "storage_key": "property/6767906449166559/019d02cf-1776-7794-b9b6-53da6409411f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.jakers.com/meridian",
      "poi_directions_map_url": "https://maps.google.com/?cid=17091299301262104361&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jakers-bar-and-grill",
      "poi_latitude": "43.6135192",
      "poi_longitude": "-116.3523413",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 208-288-0898",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-a6e0-7084-945a-976d27438bdf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-a6e0-7084-945a-976d27438bdf",
        "storage_key": "property/6767906449166559/019d02cf-a6e0-7084-945a-976d27438bdf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI0-QKhpUrlQRKRecMSl-MO0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_f3d5c4f1-4981-49e9-9d01-8ce4d45c2373",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Grimaldi's Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "3573 E Longwing Ln Suite 130, Meridian, ID 83646, USA",
      "poi_short_description": "Casual, Brooklyn-based pizzeria chain serving brick-oven pies & calzones, plus wine & beer.",
      "poi_long_description": "Casual, Brooklyn-based pizzeria chain serving brick-oven pies & calzones, plus wine & beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-187f-74dc-ad5e-470f35da4d5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-187f-74dc-ad5e-470f35da4d5b",
        "storage_key": "property/6767906449166559/019d02cf-187f-74dc-ad5e-470f35da4d5b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.grimaldispizzeria.com/locations/meridian/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7711271359378990298&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grimaldis-pizzeria",
      "poi_latitude": "43.621582",
      "poi_longitude": "-116.349353",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 208-884-2031",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-a60c-71a6-897a-37f961c0f1ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-a60c-71a6-897a-37f961c0f1ce",
        "storage_key": "property/6767906449166559/019d02cf-a60c-71a6-897a-37f961c0f1ce.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqcUj_T1UrlQR2qRt_nHwA2s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_6939f19f-e4b7-4c3d-b937-6f52d107a4b7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Kona Grill - Boise",
      "poi_type": "Restaurants",
      "poi_address": "3573 E Longwing Ln STE 140, Meridian, ID 83646, USA",
      "poi_short_description": "Sleek chain with a broad New American menu including low-calorie options, plus sushi & cocktails.",
      "poi_long_description": "Sleek chain with a broad New American menu including low-calorie options, plus sushi & cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-17fa-706b-bd3a-13c0026d7d81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-17fa-706b-bd3a-13c0026d7d81",
        "storage_key": "property/6767906449166559/019d02cf-17fa-706b-bd3a-13c0026d7d81.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://konagrill.com/locations?locations=Meridian,83646",
      "poi_directions_map_url": "https://maps.google.com/?cid=1871143878583956550&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kona-grill---boise",
      "poi_latitude": "43.6212393",
      "poi_longitude": "-116.3492632",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 208-922-6511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-a60c-71a6-897a-37f961c0f1ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-a60c-71a6-897a-37f961c0f1ce",
        "storage_key": "property/6767906449166559/019d02cf-a60c-71a6-897a-37f961c0f1ce.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqcUj_T1UrlQRRrSknnGj9xk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_5c7a9037-504b-4d15-bbf1-a698242c0a0b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Yard House",
      "poi_type": "Restaurants",
      "poi_address": "3693 E Longwing Ln Suite #140, Meridian, ID 83646, USA",
      "poi_short_description": "High-end sports-bar chain with a huge menu of New American fare & an extensive list of draft beers.",
      "poi_long_description": "High-end sports-bar chain with a huge menu of New American fare & an extensive list of draft beers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-18ce-7019-9f1c-bdcce7fdbfd0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-18ce-7019-9f1c-bdcce7fdbfd0",
        "storage_key": "property/6767906449166559/019d02cf-18ce-7019-9f1c-bdcce7fdbfd0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.yardhouse.com/locations/id/meridian/boise-village-at-meridian/8351?cmpid=br:yh_ag:ie_ch:loc_ca:YHGMB_sn:gmb_gt:meridian-id-8351_pl:locurl_rd:1048",
      "poi_directions_map_url": "https://maps.google.com/?cid=4198983688274683723&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yard-house",
      "poi_latitude": "43.62158549999999",
      "poi_longitude": "-116.3484509",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 208-288-0990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-a60c-71a6-897a-37f961c0f1ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-a60c-71a6-897a-37f961c0f1ce",
        "storage_key": "property/6767906449166559/019d02cf-a60c-71a6-897a-37f961c0f1ce.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9VgJCRZUrlQRS6dF1WrJRTo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_7d4908e4-ec34-4c53-aa32-2ad88f9d9269",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Matador Meridian",
      "poi_type": "Restaurants",
      "poi_address": "3690 E Monarch Sky Ln #140, Meridian, ID 83646, USA",
      "poi_short_description": "Local bar chain serving classic & contemporary Mexican dishes, plus cocktails, in a stylish space.",
      "poi_long_description": "Local bar chain serving classic & contemporary Mexican dishes, plus cocktails, in a stylish space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-1e18-770c-89ab-18bc68cf89d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-1e18-770c-89ab-18bc68cf89d6",
        "storage_key": "property/6767906449166559/019d02cf-1e18-770c-89ab-18bc68cf89d6.webp",
        "width": 1126,
        "height": 751
      },
      "poi_business_url": "https://matadorrestaurants.com/locations/meridian",
      "poi_directions_map_url": "https://maps.google.com/?cid=5892145173156658240&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "matador-meridian",
      "poi_latitude": "43.62076649999999",
      "poi_longitude": "-116.3484422",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 208-893-6120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-a60c-71a6-897a-37f961c0f1ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-a60c-71a6-897a-37f961c0f1ce",
        "storage_key": "property/6767906449166559/019d02cf-a60c-71a6-897a-37f961c0f1ce.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc1jD3j1UrlQRQPwIK9EaxVE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_7447e9cf-7d93-4a53-9987-0d7785151459",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "3801 E Fairview Ave, Meridian, ID 83642, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-1ff1-7751-ae9f-84f8c018aef4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-1ff1-7751-ae9f-84f8c018aef4",
        "storage_key": "property/6767906449166559/019d02cf-1ff1-7751-ae9f-84f8c018aef4.webp",
        "width": 1280,
        "height": 757
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/idaho/boise?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=13690014926831158&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "43.61907850000001",
      "poi_longitude": "-116.3473082",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 208-887-9401",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-a60c-71a6-897a-37f961c0f1ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-a60c-71a6-897a-37f961c0f1ce",
        "storage_key": "property/6767906449166559/019d02cf-a60c-71a6-897a-37f961c0f1ce.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpSjjkDxUrlQRNv6u_P6iMAA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_eeb354f3-e1fa-4c76-a14b-9c9dd33a99fd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Goodwood Barbecue Company",
      "poi_type": "Restaurants",
      "poi_address": "1140 N Eagle Rd, Meridian, ID 83642, USA",
      "poi_short_description": "Down-home chain BBQ joint specializing in pit-smoked meats, plus sauces & sides made from scratch.",
      "poi_long_description": "Down-home chain BBQ joint specializing in pit-smoked meats, plus sauces & sides made from scratch.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-1fc5-7049-813f-d4fdf4ebe797.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-1fc5-7049-813f-d4fdf4ebe797",
        "storage_key": "property/6767906449166559/019d02cf-1fc5-7049-813f-d4fdf4ebe797.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "http://www.goodwoodbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13584383592096414539&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "goodwood-barbecue-company",
      "poi_latitude": "43.614756",
      "poi_longitude": "-116.353915",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 208-884-1021",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-a60c-71a6-897a-37f961c0f1ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-a60c-71a6-897a-37f961c0f1ce",
        "storage_key": "property/6767906449166559/019d02cf-a60c-71a6-897a-37f961c0f1ce.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhW7_qhBUrlQRSzuNY-dshbw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_b0a833d3-783b-465b-a1c0-1fc1b92478e8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Lucky Fins Meridian",
      "poi_type": "Restaurants",
      "poi_address": "1441 N Eagle Rd, Meridian, ID 83642, USA",
      "poi_short_description": "Hip modern eatery serves an array of seafood dishes, sushi & American fare in a bright, airy space.",
      "poi_long_description": "Hip modern eatery serves an array of seafood dishes, sushi & American fare in a bright, airy space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-1f9a-76a8-b823-3d4897eeb2d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-1f9a-76a8-b823-3d4897eeb2d9",
        "storage_key": "property/6767906449166559/019d02cf-1f9a-76a8-b823-3d4897eeb2d9.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://www.luckyfinsrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1933058238418703317&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lucky-fins-meridian",
      "poi_latitude": "43.61779920000001",
      "poi_longitude": "-116.3556875",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 208-888-3467",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-a60c-71a6-897a-37f961c0f1ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-a60c-71a6-897a-37f961c0f1ce",
        "storage_key": "property/6767906449166559/019d02cf-a60c-71a6-897a-37f961c0f1ce.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRwTv3hZUrlQR1dMW3zma0xo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_95597901-fdea-4443-9fe8-52e86c7c95e1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Louie's Pizza & Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2500 E Fairview Ave, Meridian, ID 83642, USA",
      "poi_short_description": "Italian eatery offers classic fare served family-style in a large space with an old-world ambiance.",
      "poi_long_description": "Italian eatery offers classic fare served family-style in a large space with an old-world ambiance.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-263b-751c-ba6c-cda704ed4c8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-263b-751c-ba6c-cda704ed4c8c",
        "storage_key": "property/6767906449166559/019d02cf-263b-751c-ba6c-cda704ed4c8c.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.louiespizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=111260069037329775&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "louies-pizza--italian-restaurant",
      "poi_latitude": "43.6199968",
      "poi_longitude": "-116.3634342",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 208-884-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-a60c-71a6-897a-37f961c0f1ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-a60c-71a6-897a-37f961c0f1ce",
        "storage_key": "property/6767906449166559/019d02cf-a60c-71a6-897a-37f961c0f1ce.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJfadoRBJUrlQRb82nfHFGiwE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_467aec3f-841a-4b1c-aad0-fc726fff27b9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Sa-Wad-Dee Thai Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1890 E Fairview Ave, Meridian, ID 83642, USA",
      "poi_short_description": "This laid-back spot serves classic Thai dishes & Asian eats amid a backdrop of cultural decorations.",
      "poi_long_description": "This laid-back spot serves classic Thai dishes & Asian eats amid a backdrop of cultural decorations.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-271b-76ed-aaef-5b0ac417ada2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-271b-76ed-aaef-5b0ac417ada2",
        "storage_key": "property/6767906449166559/019d02cf-271b-76ed-aaef-5b0ac417ada2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sawaddeethai.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15148426727486634380&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sa-wad-dee-thai-restaurant",
      "poi_latitude": "43.6199733",
      "poi_longitude": "-116.3707616",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 208-884-0701",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-a60c-71a6-897a-37f961c0f1ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-a60c-71a6-897a-37f961c0f1ce",
        "storage_key": "property/6767906449166559/019d02cf-a60c-71a6-897a-37f961c0f1ce.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7xnN3QxUrlQRjLnfTdkFOtI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_9078db0a-97e6-4f7c-8d4c-8102f3cde5a9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Ling & Louie's Asian Bar and Grill",
      "poi_type": "Restaurants",
      "poi_address": "3210 E Louise Dr, Meridian, ID 83642, USA",
      "poi_short_description": "Casual Asian restaurant with a lively vibe also offering some American eats, plus a full bar.",
      "poi_long_description": "Casual Asian restaurant with a lively vibe also offering some American eats, plus a full bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-2786-7340-aceb-44eedbe6f444.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-2786-7340-aceb-44eedbe6f444",
        "storage_key": "property/6767906449166559/019d02cf-2786-7340-aceb-44eedbe6f444.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lingandlouies.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11106873814720473524&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ling--louies-asian-bar-and-grill",
      "poi_latitude": "43.6033759",
      "poi_longitude": "-116.3540941",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 208-888-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-a60c-71a6-897a-37f961c0f1ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-a60c-71a6-897a-37f961c0f1ce",
        "storage_key": "property/6767906449166559/019d02cf-a60c-71a6-897a-37f961c0f1ce.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJrVH3B6lWrlQRtGmAQ-OKI5o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_restaurant"
    },
    {
      "id": "custom_272d711a-a54e-411d-918b-23a12ff8508b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Albertsons",
      "poi_type": "Shopping & Retail",
      "poi_address": "20 E Fairview Ave, Meridian, ID 83642, USA",
      "poi_short_description": "Chain featuring produce, meat and seafood, plus a deli and a bakery that customizes cakes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-26e9-7088-9f5f-e7797fcbf2c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-26e9-7088-9f5f-e7797fcbf2c4",
        "storage_key": "property/6767906449166559/019d02cf-26e9-7088-9f5f-e7797fcbf2c4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://local.albertsons.com/id/meridian/20-e-fairview-ave.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=10517665381167297287&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "albertsons",
      "poi_latitude": "43.6206198",
      "poi_longitude": "-116.3927727",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 208-888-4792",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-a645-76fb-8a01-006cd4dcf968.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-a645-76fb-8a01-006cd4dcf968",
        "storage_key": "property/6767906449166559/019d02cf-a645-76fb-8a01-006cd4dcf968.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS9NMJoxTrlQRB3PmbvBA9pE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_f620dabc-aaa3-4f6d-b7b1-75b3ebe846b3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Fred Meyer",
      "poi_type": "Shopping & Retail",
      "poi_address": "1850 E Fairview Ave, Meridian, ID 83642, USA",
      "poi_short_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_long_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-2ee6-74f9-8fd7-4b9ba2ea4746.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-2ee6-74f9-8fd7-4b9ba2ea4746",
        "storage_key": "property/6767906449166559/019d02cf-2ee6-74f9-8fd7-4b9ba2ea4746.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.fredmeyer.com/stores/grocery/id/meridian/meridian/701/00198?cid=loc_70100198_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=14091890768888476152&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fred-meyer",
      "poi_latitude": "43.6210949",
      "poi_longitude": "-116.3726056",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 208-887-5240",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-a645-76fb-8a01-006cd4dcf968.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-a645-76fb-8a01-006cd4dcf968",
        "storage_key": "property/6767906449166559/019d02cf-a645-76fb-8a01-006cd4dcf968.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWa6fM3NUrlQR-DE0Bf5zkMM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_9dec12d3-c1e6-4f9e-9e4c-b7e7a1d17ab3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "1050 S Progress Ave, Meridian, ID 83642, USA",
      "poi_short_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_long_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-2e30-7445-b8e3-fee18ae88dbb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-2e30-7445-b8e3-fee18ae88dbb",
        "storage_key": "property/6767906449166559/019d02cf-2e30-7445-b8e3-fee18ae88dbb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6540332968631934767&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "43.5962319",
      "poi_longitude": "-116.3896895",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 208-888-3881",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-a645-76fb-8a01-006cd4dcf968.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-a645-76fb-8a01-006cd4dcf968",
        "storage_key": "property/6767906449166559/019d02cf-a645-76fb-8a01-006cd4dcf968.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD5lAGmBRrlQRLx8VzC7uw1o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_6dfa1ff6-172c-40c4-9e7e-24de9e030eaf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "4051 E Fairview Ave, Meridian, ID 83642, USA",
      "poi_short_description": "Department store chain stocking a wide selection of merchandise, including apparel, electronics, furniture, and home goods.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-2f44-725c-a5e0-58f85d59e756.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-2f44-725c-a5e0-58f85d59e756",
        "storage_key": "property/6767906449166559/019d02cf-2f44-725c-a5e0-58f85d59e756.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "https://www.walmart.com/store/2862-meridian-id/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=5534398539963343319&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "43.6181515",
      "poi_longitude": "-116.3440557",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 208-373-7908",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-ab72-7318-89d6-cb4328a5bf41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-ab72-7318-89d6-cb4328a5bf41",
        "storage_key": "property/6767906449166559/019d02cf-ab72-7318-89d6-cb4328a5bf41.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJOy0KkTxUrlQR16H0SyYizkw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_ee15d660-7ca5-4dbc-95c9-e1743da972fb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "The Village at Meridian",
      "poi_type": "Shopping & Retail",
      "poi_address": "3597 E Monarch Sky Ln #225, Meridian, ID 83646, USA",
      "poi_short_description": "Outdoor shopping mall with familiar chains, casual dining options, a play area & a movie theater.",
      "poi_long_description": "Outdoor shopping mall with familiar chains, casual dining options, a play area & a movie theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-30e2-7200-a828-8d9978dad520.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-30e2-7200-a828-8d9978dad520",
        "storage_key": "property/6767906449166559/019d02cf-30e2-7200-a828-8d9978dad520.webp",
        "width": 848,
        "height": 1280
      },
      "poi_business_url": "https://www.thevillageatmeridian.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7993224528498054073&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-village-at-meridian",
      "poi_latitude": "43.6208703",
      "poi_longitude": "-116.3492707",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 208-501-8207",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-ab72-7318-89d6-cb4328a5bf41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-ab72-7318-89d6-cb4328a5bf41",
        "storage_key": "property/6767906449166559/019d02cf-ab72-7318-89d6-cb4328a5bf41.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJI-mQ7z5UrlQRudMQ11uj7W4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_fd8a044d-fbbf-4838-b740-27d76e0253dd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Meridian Crossroads",
      "poi_type": "Shopping & Retail",
      "poi_address": "E Fairview Ave, Meridian, ID 83642, USA",
      "poi_short_description": "Shopping center featuring a variety of retail chains as well as family-oriented eateries and some outdoor space.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-355d-76ee-9489-d6c8206660eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-355d-76ee-9489-d6c8206660eb",
        "storage_key": "property/6767906449166559/019d02cf-355d-76ee-9489-d6c8206660eb.webp",
        "width": 1024,
        "height": 640
      },
      "poi_business_url": "https://www.meridiancrossroads.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9029749969555031562&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meridian-crossroads",
      "poi_latitude": "43.6178629",
      "poi_longitude": "-116.3507266",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 877-206-5656",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-ab72-7318-89d6-cb4328a5bf41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-ab72-7318-89d6-cb4328a5bf41",
        "storage_key": "property/6767906449166559/019d02cf-ab72-7318-89d6-cb4328a5bf41.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ6yDQ_xdUrlQRCgbsccEdUH0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_5b54a007-3188-4122-8e50-0b115315e48d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Kohl's",
      "poi_type": "Shopping & Retail",
      "poi_address": "3275 N Eagle Rd, Meridian, ID 83646, USA",
      "poi_short_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_long_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-358c-70a8-8d9c-53a192a7452d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-358c-70a8-8d9c-53a192a7452d",
        "storage_key": "property/6767906449166559/019d02cf-358c-70a8-8d9c-53a192a7452d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.kohls.com/stores/id/meridian-1094.shtml?utm_source=google&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=8666975768118397623&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kohls",
      "poi_latitude": "43.6345908",
      "poi_longitude": "-116.3577209",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 208-846-8974",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-ab72-7318-89d6-cb4328a5bf41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-ab72-7318-89d6-cb4328a5bf41",
        "storage_key": "property/6767906449166559/019d02cf-ab72-7318-89d6-cb4328a5bf41.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJxRMFUFtUrlQRt4qdn4pIR3g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_c093c8c4-4dfa-466d-9179-ade4ce09cc75",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Ross Dress for Less",
      "poi_type": "Shopping & Retail",
      "poi_address": "3553 E Fairview Ave, Meridian, ID 83642, USA",
      "poi_short_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_long_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-369f-74b5-8c9f-a6e8d0483481.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-369f-74b5-8c9f-a6e8d0483481",
        "storage_key": "property/6767906449166559/019d02cf-369f-74b5-8c9f-a6e8d0483481.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.rossstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16923997202850902638&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ross-dress-for-less",
      "poi_latitude": "43.6178478",
      "poi_longitude": "-116.3495469",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 208-884-3135",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-ab72-7318-89d6-cb4328a5bf41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-ab72-7318-89d6-cb4328a5bf41",
        "storage_key": "property/6767906449166559/019d02cf-ab72-7318-89d6-cb4328a5bf41.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJGyJihT1UrlQRbvKh78kd3uo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_ce7a37fd-dc12-4eb9-ae92-7a3fb6644d5d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Sportsman's Warehouse",
      "poi_type": "Shopping & Retail",
      "poi_address": "3797 E Fairview Ave, Meridian, ID 83642, USA",
      "poi_short_description": "Outdoor recreation chain featuring apparel, footwear, equipment & accessories for adults & kids.",
      "poi_long_description": "Outdoor recreation chain featuring apparel, footwear, equipment & accessories for adults & kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-3865-778a-8fff-7fbdca78d28f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-3865-778a-8fff-7fbdca78d28f",
        "storage_key": "property/6767906449166559/019d02cf-3865-778a-8fff-7fbdca78d28f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.sportsmans.com/sportsmans-warehouse/us/id/meridian/3797-e-fairview-avenue?utm_source=google&utm_medium=organic&utm_campaign=GMB&y_source=1_OTg4MDE5MS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=7332731416767351833&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sportsmans-warehouse",
      "poi_latitude": "43.6176791",
      "poi_longitude": "-116.3476402",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 208-884-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-ab72-7318-89d6-cb4328a5bf41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-ab72-7318-89d6-cb4328a5bf41",
        "storage_key": "property/6767906449166559/019d02cf-ab72-7318-89d6-cb4328a5bf41.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJn6UCkTxUrlQRGczDgV8Yw2U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_e3f40600-abdf-445c-ac1a-351fdea596ec",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Maverik",
      "poi_type": "Shopping & Retail",
      "poi_address": "1515 E Fairview Ave, Meridian, ID 83642, USA",
      "poi_short_description": "Gas-station & convenience store chain, serving drinks & snacks from burritos to frozen yogurt.",
      "poi_long_description": "Gas-station & convenience store chain, serving drinks & snacks from burritos to frozen yogurt.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-3c88-70ce-986f-28d624eed93e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-3c88-70ce-986f-28d624eed93e",
        "storage_key": "property/6767906449166559/019d02cf-3c88-70ce-986f-28d624eed93e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.maverik.com/id/meridian/1515-e.-fairview-avenue",
      "poi_directions_map_url": "https://maps.google.com/?cid=7286629218016233398&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maverik",
      "poi_latitude": "43.6190379",
      "poi_longitude": "-116.3755926",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 208-888-8012",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-ab75-7788-bdbf-724bdcb0f031.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-ab75-7788-bdbf-724bdcb0f031",
        "storage_key": "property/6767906449166559/019d02cf-ab75-7788-bdbf-724bdcb0f031.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0en8aTNVrlQRtgfX5apOH2U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_13fc7962-51bb-4e04-8f2d-66a6c51cac86",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Lewis & Clark Middle School",
      "poi_type": "Education",
      "poi_address": "4141 E Pine Ave, Meridian, ID 83642, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-3d2e-705a-9831-305f4913fbda.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-3d2e-705a-9831-305f4913fbda",
        "storage_key": "property/6767906449166559/019d02cf-3d2e-705a-9831-305f4913fbda.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "http://www.westada.org/LCMS",
      "poi_directions_map_url": "https://maps.google.com/?cid=16190241355924047663&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lewis--clark-middle-school",
      "poi_latitude": "43.6111788",
      "poi_longitude": "-116.3419481",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 208-350-4270",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-ab75-7788-bdbf-77dd40b01492.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-ab75-7788-bdbf-77dd40b01492",
        "storage_key": "property/6767906449166559/019d02cf-ab75-7788-bdbf-77dd40b01492.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAcE4ih9UrlQRLwexz7tKr-A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_4f4959d5-d852-487e-82d4-72fa6775cfcd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Meridian Middle School",
      "poi_type": "Education",
      "poi_address": "1507 8th St NW, Meridian, ID 83642, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-3e9f-71ec-9093-cb5c3bb4d316.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-3e9f-71ec-9093-cb5c3bb4d316",
        "storage_key": "property/6767906449166559/019d02cf-3e9f-71ec-9093-cb5c3bb4d316.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.westada.org/o/mms",
      "poi_directions_map_url": "https://maps.google.com/?cid=7925409437925360136&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meridian-middle-school",
      "poi_latitude": "43.6179697",
      "poi_longitude": "-116.4044028",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 208-855-4225",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-ab75-7788-bdbf-77dd40b01492.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-ab75-7788-bdbf-77dd40b01492",
        "storage_key": "property/6767906449166559/019d02cf-ab75-7788-bdbf-77dd40b01492.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjbBmh5ZTrlQRCMIRp-S1_G0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_c09f1787-3bb2-41c9-909b-b2e3df25944a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Meridian Elementary School",
      "poi_type": "Education",
      "poi_address": "1035 NW 1st St, Meridian, ID 83642, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-4094-7388-8549-3cf98284f6a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-4094-7388-8549-3cf98284f6a9",
        "storage_key": "property/6767906449166559/019d02cf-4094-7388-8549-3cf98284f6a9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.westada.org/o/MES",
      "poi_directions_map_url": "https://maps.google.com/?cid=11327492548001318162&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meridian-elementary-school",
      "poi_latitude": "43.6130933",
      "poi_longitude": "-116.3948819",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 208-855-4335",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-ab75-7788-bdbf-77dd40b01492.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-ab75-7788-bdbf-77dd40b01492",
        "storage_key": "property/6767906449166559/019d02cf-ab75-7788-bdbf-77dd40b01492.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLe2RAO1TrlQREsWA73RWM50",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_6753fb9c-13d4-4c21-8e8f-0394705ff810",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Discovery Elementary School",
      "poi_type": "Education",
      "poi_address": "2100 E Leigh Fld Dr, Meridian, ID 83646, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.westada.org/discovery",
      "poi_directions_map_url": "https://maps.google.com/?cid=5819151719616235657&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "discovery-elementary-school",
      "poi_latitude": "43.640404",
      "poi_longitude": "-116.368171",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 208-855-4090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-ab75-7788-bdbf-77dd40b01492.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-ab75-7788-bdbf-77dd40b01492",
        "storage_key": "property/6767906449166559/019d02cf-ab75-7788-bdbf-77dd40b01492.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZVJBQ_VUrlQRiUjUZajHwVA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_a31964a4-7f3c-4641-84ff-a00c746d2552",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Ustick Elementary school",
      "poi_type": "Education",
      "poi_address": "12435 W Ustick Rd, Boise, ID 83713, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.westada.org/o/ue",
      "poi_directions_map_url": "https://maps.google.com/?cid=14421449998740948838&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ustick-elementary-school",
      "poi_latitude": "43.63331669999999",
      "poi_longitude": "-116.3378977",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 208-855-4120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-ab75-7788-bdbf-77dd40b01492.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-ab75-7788-bdbf-77dd40b01492",
        "storage_key": "property/6767906449166559/019d02cf-ab75-7788-bdbf-77dd40b01492.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJq05Nl0tUrlQRZgcDoV1II8g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_67320ca6-1fbe-46b2-abf2-03ae1cb647d1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Meridian High School",
      "poi_type": "Education",
      "poi_address": "1900 W Pine Ave, Meridian, ID 83642, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-4347-715b-ba80-02999cc62e82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-4347-715b-ba80-02999cc62e82",
        "storage_key": "property/6767906449166559/019d02cf-4347-715b-ba80-02999cc62e82.webp",
        "width": 1280,
        "height": 948
      },
      "poi_business_url": "http://www.westada.org/MHS",
      "poi_directions_map_url": "https://maps.google.com/?cid=8883237381289393268&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meridian-high-school",
      "poi_latitude": "43.6135996",
      "poi_longitude": "-116.4165878",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 208-350-4160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-ab75-7788-bdbf-77dd40b01492.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-ab75-7788-bdbf-77dd40b01492",
        "storage_key": "property/6767906449166559/019d02cf-ab75-7788-bdbf-77dd40b01492.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2yeGhfJTrlQRdLw5N1WZR3s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_ab50e9bc-f792-4a33-a405-0fee47b4ac0d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Kiddie Academy of Meridian",
      "poi_type": "Education",
      "poi_address": "3335 E Victory Rd, Meridian, ID 83642, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-4462-751a-b918-2a60eb6c3194.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-4462-751a-b918-2a60eb6c3194",
        "storage_key": "property/6767906449166559/019d02cf-4462-751a-b918-2a60eb6c3194.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://kiddieacademy.com/academies/meridian/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16936666820842747651&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kiddie-academy-of-meridian",
      "poi_latitude": "43.5752442",
      "poi_longitude": "-116.352761",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 208-508-2415",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-ab75-7788-bdbf-77dd40b01492.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-ab75-7788-bdbf-77dd40b01492",
        "storage_key": "property/6767906449166559/019d02cf-ab75-7788-bdbf-77dd40b01492.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGaSVOptRrlQRA_d5P70gC-s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_9d8d89b6-4ee0-4333-9047-621ad0674769",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Treehouse Kids Academy",
      "poi_type": "Education",
      "poi_address": "444 N Linder Rd, Meridian, ID 83642, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-4674-761e-9f91-3d772c3a5f21.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-4674-761e-9f91-3d772c3a5f21",
        "storage_key": "property/6767906449166559/019d02cf-4674-761e-9f91-3d772c3a5f21.webp",
        "width": 480,
        "height": 640
      },
      "poi_business_url": "https://www.treehousekidsacademy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6870722973511977550&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "treehouse-kids-academy",
      "poi_latitude": "43.6083595",
      "poi_longitude": "-116.4130178",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 208-888-2801",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-ab75-7788-bdbf-77dd40b01492.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-ab75-7788-bdbf-77dd40b01492",
        "storage_key": "property/6767906449166559/019d02cf-ab75-7788-bdbf-77dd40b01492.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJgZ0lyI1TrlQRTgpMSiS2WV8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_d8e4e201-585a-4c28-b73a-614ab1ed58ac",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Northwest Nazarene University",
      "poi_type": "Education",
      "poi_address": "623 S University Blvd, Nampa, ID 83686, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-48af-7236-9315-f5bf1f10412b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-48af-7236-9315-f5bf1f10412b",
        "storage_key": "property/6767906449166559/019d02cf-48af-7236-9315-f5bf1f10412b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.nnu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7956963679509420113&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northwest-nazarene-university",
      "poi_latitude": "43.5614966",
      "poi_longitude": "-116.5656946",
      "poi_miles_from_property": "14.1",
      "poi_walking_minutes": "5 hours 9 mins",
      "poi_biking_minutes": "1 hour 19 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 208-467-8011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-ab75-7788-bdbf-77dd40b01492.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-ab75-7788-bdbf-77dd40b01492",
        "storage_key": "property/6767906449166559/019d02cf-ab75-7788-bdbf-77dd40b01492.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHx8UlgdMrlQRURjYB0_QbG4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_053d44c1-9705-426d-8d39-8a813bf03704",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Village Cinema",
      "poi_type": "Entertainment",
      "poi_address": "3711 E Longwing Ln, Meridian, ID 83646, USA",
      "poi_short_description": "Chain theater showing 3D films in stadium seating with an arcade.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-4b5c-74c2-b12d-0304109ca8fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-4b5c-74c2-b12d-0304109ca8fd",
        "storage_key": "property/6767906449166559/019d02cf-4b5c-74c2-b12d-0304109ca8fd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://web.cinemawest.com/sites/Village-Cinema/1601",
      "poi_directions_map_url": "https://maps.google.com/?cid=7177664473271300457&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "village-cinema",
      "poi_latitude": "43.6214316",
      "poi_longitude": "-116.3479354",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 208-995-2942",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-abfd-7538-ba7c-2e7dc2a3456e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-abfd-7538-ba7c-2e7dc2a3456e",
        "storage_key": "property/6767906449166559/019d02cf-abfd-7538-ba7c-2e7dc2a3456e.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJK4c1LzxUrlQRafFGPs8vnGM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_d44a5d36-090e-4f56-9e23-49895aef2d8f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Cinemark Majestic Cinemas",
      "poi_type": "Entertainment",
      "poi_address": "2140 E Cinema Dr, Meridian, ID 83642, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-4c36-70ea-8dab-0eeaef82443e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-4c36-70ea-8dab-0eeaef82443e",
        "storage_key": "property/6767906449166559/019d02cf-4c36-70ea-8dab-0eeaef82443e.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.cinemark.com/theatres/id-meridian/cinemark-majestic-cinemas?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTMyMDgtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=3428330524865489837&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-majestic-cinemas",
      "poi_latitude": "43.5923202",
      "poi_longitude": "-116.3689922",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 208-893-5028",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-abfd-7538-ba7c-2e7dc2a3456e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-abfd-7538-ba7c-2e7dc2a3456e",
        "storage_key": "property/6767906449166559/019d02cf-abfd-7538-ba7c-2e7dc2a3456e.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ09Gpw09RrlQRrWs8w3Lgky8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_3a7fb0d7-ac52-4830-b34b-acac5385d504",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Roaring Springs Water Park",
      "poi_type": "Entertainment",
      "poi_address": "400 W Overland Rd, Meridian, ID 83642, USA",
      "poi_short_description": "Sprawling water park with a wave pool, lazy river rafting & lots of waterslides, plus food & drink.",
      "poi_long_description": "Sprawling water park with a wave pool, lazy river rafting & lots of waterslides, plus food & drink.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-4e46-72fa-9e88-8f5aa3caae19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-4e46-72fa-9e88-8f5aa3caae19",
        "storage_key": "property/6767906449166559/019d02cf-4e46-72fa-9e88-8f5aa3caae19.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.roaringsprings.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8152653125388609522&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "roaring-springs-water-park",
      "poi_latitude": "43.5910243",
      "poi_longitude": "-116.3982357",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 208-884-8842",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-b056-7788-92ff-9393c9b020c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-b056-7788-92ff-9393c9b020c6",
        "storage_key": "property/6767906449166559/019d02cf-b056-7788-92ff-9393c9b020c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN8aHL2NRrlQR8ifEq9IKJHE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_f9ff62b1-7d72-4924-9925-7898ebdb5caa",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Wahooz Family Fun Zone",
      "poi_type": "Entertainment",
      "poi_address": "1385 S Blue Marlin Ln, Meridian, ID 83642, USA",
      "poi_short_description": "Spacious entertainment center features go-karts, mini-golf, arcade games & more, plus food & drink.",
      "poi_long_description": "Spacious entertainment center features go-karts, mini-golf, arcade games & more, plus food & drink.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-515f-735e-9ce5-9a93bf745dab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-515f-735e-9ce5-9a93bf745dab",
        "storage_key": "property/6767906449166559/019d02cf-515f-735e-9ce5-9a93bf745dab.webp",
        "width": 1280,
        "height": 856
      },
      "poi_business_url": "http://www.wahoozfunzone.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4166788890632256433&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wahooz-family-fun-zone",
      "poi_latitude": "43.5923042",
      "poi_longitude": "-116.4005279",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 208-898-0900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-b056-7788-92ff-9393c9b020c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-b056-7788-92ff-9393c9b020c6",
        "storage_key": "property/6767906449166559/019d02cf-b056-7788-92ff-9393c9b020c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ4_SMn1RrlQRsfstYGto0zk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_40367e70-71dd-404b-915b-2af7983e5b3f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Pinz Bowling Center",
      "poi_type": "Entertainment",
      "poi_address": "1385 S Blue Marlin Ln, Meridian, ID 83642, USA",
      "poi_short_description": "Bowling alley offering a variety of skill levels, leagues, and active military discounts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-533a-7379-a542-2eb90bf197a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-533a-7379-a542-2eb90bf197a2",
        "storage_key": "property/6767906449166559/019d02cf-533a-7379-a542-2eb90bf197a2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.pinzbowlingidaho.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3426005436704373516&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pinz-bowling-center",
      "poi_latitude": "43.5920816",
      "poi_longitude": "-116.4002216",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 208-898-0900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-b056-7788-92ff-9393c9b020c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-b056-7788-92ff-9393c9b020c6",
        "storage_key": "property/6767906449166559/019d02cf-b056-7788-92ff-9393c9b020c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ4_SMn1RrlQRDDtS_cqdiy8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_e11951f1-0737-4dfa-9f1f-c9a69931be71",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Meridian Speedway",
      "poi_type": "Entertainment",
      "poi_address": "335 S Main St #2971, Meridian, ID 83642, USA",
      "poi_short_description": "Outdoor track with weekend asphalt- & dirt-track auto races, stadium seating & standard concessions.",
      "poi_long_description": "Outdoor track with weekend asphalt- & dirt-track auto races, stadium seating & standard concessions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-566f-771c-a523-ccc3bea52380.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-566f-771c-a523-ccc3bea52380",
        "storage_key": "property/6767906449166559/019d02cf-566f-771c-a523-ccc3bea52380.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://meridianspeedway.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13040287850010664570&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meridian-speedway",
      "poi_latitude": "43.6027488",
      "poi_longitude": "-116.3911132",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 208-888-2813",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-b056-7788-92ff-9393c9b020c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-b056-7788-92ff-9393c9b020c6",
        "storage_key": "property/6767906449166559/019d02cf-b056-7788-92ff-9393c9b020c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSVwPMOdTrlQRel66jLVo-LQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_040cf406-697f-4ef0-bbc8-285be1fde536",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "BoDo CINEMA",
      "poi_type": "Entertainment",
      "poi_address": "760 W Broad St 2nd Floor, Boise, ID 83702, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-59de-76e8-87d5-e123f2d7dc54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-59de-76e8-87d5-e123f2d7dc54",
        "storage_key": "property/6767906449166559/019d02cf-59de-76e8-87d5-e123f2d7dc54.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://web.cinemawest.com/sites/BoDo-Cinema/1801",
      "poi_directions_map_url": "https://maps.google.com/?cid=8741855141082599585&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bodo-cinema",
      "poi_latitude": "43.613306",
      "poi_longitude": "-116.204923",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 208-514-1398",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-abfd-7538-ba7c-2e7dc2a3456e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-abfd-7538-ba7c-2e7dc2a3456e",
        "storage_key": "property/6767906449166559/019d02cf-abfd-7538-ba7c-2e7dc2a3456e.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJuRV3EuL5rlQRoZAmOu9OUXk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_3191a439-68f4-4754-aed8-e6f31af4f164",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Boise Art Museum",
      "poi_type": "Entertainment",
      "poi_address": "670 Julia Davis Dr, Boise, ID 83702, USA",
      "poi_short_description": "Contemporary artwork & exhibitions housed in an art deco building, with an outdoor sculpture garden.",
      "poi_long_description": "Contemporary artwork & exhibitions housed in an art deco building, with an outdoor sculpture garden.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-5ba2-7269-8adf-b66ccd590b66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-5ba2-7269-8adf-b66ccd590b66",
        "storage_key": "property/6767906449166559/019d02cf-5ba2-7269-8adf-b66ccd590b66.webp",
        "width": 1280,
        "height": 878
      },
      "poi_business_url": "http://www.boiseartmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7195344784222626104&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boise-art-museum",
      "poi_latitude": "43.60974179999999",
      "poi_longitude": "-116.2064251",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 208-345-8330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-b07f-75fb-a059-dded3e187812.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-b07f-75fb-a059-dded3e187812",
        "storage_key": "property/6767906449166559/019d02cf-b07f-75fb-a059-dded3e187812.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJp0K54_D4rlQROKEMbPX_2mM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_85e0acc0-1293-4fca-9de3-cb68fff438fa",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Idaho Botanical Garden",
      "poi_type": "Entertainment",
      "poi_address": "2355 N Old Penitentiary Rd, Boise, ID 83712, USA",
      "poi_short_description": "Year-round living museum with self-guided tours through 33 acres of unique native & exotic gardens.",
      "poi_long_description": "Year-round living museum with self-guided tours through 33 acres of unique native & exotic gardens.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-5b98-727a-ab14-2c9f974b84a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-5b98-727a-ab14-2c9f974b84a4",
        "storage_key": "property/6767906449166559/019d02cf-5b98-727a-ab14-2c9f974b84a4.webp",
        "width": 1280,
        "height": 958
      },
      "poi_business_url": "https://idahobotanicalgarden.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1029028211255606636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "idaho-botanical-garden",
      "poi_latitude": "43.6017855",
      "poi_longitude": "-116.1639284",
      "poi_miles_from_property": "9.7",
      "poi_walking_minutes": "3 hours 40 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 208-343-8649",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-b06d-72d3-ad7c-65b65040a5c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-b06d-72d3-ad7c-65b65040a5c3",
        "storage_key": "property/6767906449166559/019d02cf-b06d-72d3-ad7c-65b65040a5c3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSwwlkrr5rlQRbP2-w7TXRw4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_cea91a08-90ea-4cc8-b2d1-dfc78da57b89",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "St. Luke's Meridian Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "520 S Eagle Rd, Meridian, ID 83642, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-5de5-71fc-9718-ab80cdf2d347.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-5de5-71fc-9718-ab80cdf2d347",
        "storage_key": "property/6767906449166559/019d02cf-5de5-71fc-9718-ab80cdf2d347.webp",
        "width": 540,
        "height": 440
      },
      "poi_business_url": "https://stlukesonline.org/en/get-care/locations/medical-centers/st-lukes-meridian-medical-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18298277430149943590&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-lukes-meridian-medical-center",
      "poi_latitude": "43.5995669",
      "poi_longitude": "-116.3526784",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 208-706-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-b056-7788-92ff-9393c9b020c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-b056-7788-92ff-9393c9b020c6",
        "storage_key": "property/6767906449166559/019d02cf-b056-7788-92ff-9393c9b020c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE8JRkq5WrlQRJpGi0V-K8P0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "doctor"
    },
    {
      "id": "custom_0cec912d-eed4-40e9-94a3-3c1855c133c0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Terry Reilly Health Services - Meridian Florence",
      "poi_type": "Health and Wellness",
      "poi_address": "3115 E Florence Dr, Meridian, ID 83642, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-61b3-738a-ae3e-816af93f5ddf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-61b3-738a-ae3e-816af93f5ddf",
        "storage_key": "property/6767906449166559/019d02cf-61b3-738a-ae3e-816af93f5ddf.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.trhs.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15257081113062447629&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "terry-reilly-health-services---meridian-florence",
      "poi_latitude": "43.6163694",
      "poi_longitude": "-116.3550723",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 208-991-2963",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-b0ef-73ce-a58e-c7d7a1ae978d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-b0ef-73ce-a58e-c7d7a1ae978d",
        "storage_key": "property/6767906449166559/019d02cf-b0ef-73ce-a58e-c7d7a1ae978d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJQQHp4_RVrlQRDZpo1W8KvNM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_d6dc5101-638b-4b12-a56f-610f5f464b46",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Unity Health Center and Medical Aesthetics",
      "poi_type": "Health and Wellness",
      "poi_address": "1130 E Fairview Ave, Meridian, ID 83642, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-62d8-70c2-b53b-26d91d6fccb2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-62d8-70c2-b53b-26d91d6fccb2",
        "storage_key": "property/6767906449166559/019d02cf-62d8-70c2-b53b-26d91d6fccb2.webp",
        "width": 759,
        "height": 1280
      },
      "poi_business_url": "http://www.uhcidaho.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6669608951981566074&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "unity-health-center-and-medical-aesthetics",
      "poi_latitude": "43.6198768",
      "poi_longitude": "-116.37928",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 208-895-6729",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-b056-7788-92ff-9393c9b020c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-b056-7788-92ff-9393c9b020c6",
        "storage_key": "property/6767906449166559/019d02cf-b056-7788-92ff-9393c9b020c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ94Ve0N9TrlQRemigNQE2j1w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_99fa835b-63b7-4f9f-bc7f-60f17464fb01",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "4051 E Fairview Ave, Meridian, ID 83642, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-62e2-767c-afa0-3605032ba57a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-62e2-767c-afa0-3605032ba57a",
        "storage_key": "property/6767906449166559/019d02cf-62e2-767c-afa0-3605032ba57a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walmart.com/store/2862-meridian-id/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=18184313699432886365&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "43.6181515",
      "poi_longitude": "-116.3440557",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 208-373-0024",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-b5f6-723f-bdb1-c799a484b72c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-b5f6-723f-bdb1-c799a484b72c",
        "storage_key": "property/6767906449166559/019d02cf-b5f6-723f-bdb1-c799a484b72c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-fsBmz1UrlQRXXD3CveoW_w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_80ff8343-e78d-488b-bd19-994ce03b0125",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Albertsons Market Street Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "3499 E Fairview Ave, Meridian, ID 83642, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-64a9-72a8-8181-5f4ffb7e2c0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-64a9-72a8-8181-5f4ffb7e2c0e",
        "storage_key": "property/6767906449166559/019d02cf-64a9-72a8-8181-5f4ffb7e2c0e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://local.pharmacy.albertsons.com/id/meridian/3499-e-fairview-ave.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=7682760897423318940&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "albertsons-market-street-pharmacy",
      "poi_latitude": "43.6176727",
      "poi_longitude": "-116.3511234",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 208-605-3755",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-b5f6-723f-bdb1-c799a484b72c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-b5f6-723f-bdb1-c799a484b72c",
        "storage_key": "property/6767906449166559/019d02cf-b5f6-723f-bdb1-c799a484b72c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx0a6so5VrlQRnJ8tyVSmnmo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_c526c1a8-8019-495d-854f-8630e8e69e70",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "1570 E Fairview Ave, Meridian, ID 83642, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-6942-7058-b1a9-d07faf803b31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-6942-7058-b1a9-d07faf803b31",
        "storage_key": "property/6767906449166559/019d02cf-6942-7058-b1a9-d07faf803b31.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1570+e+fairview+ave-meridian-id-83642/id=6200",
      "poi_directions_map_url": "https://maps.google.com/?cid=6805115013758330614&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "43.620164",
      "poi_longitude": "-116.3751945",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 208-888-0034",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-b056-7788-92ff-9393c9b020c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-b056-7788-92ff-9393c9b020c6",
        "storage_key": "property/6767906449166559/019d02cf-b056-7788-92ff-9393c9b020c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlZo-TQtUrlQR9ia-ygygcF4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_4f391dc6-31c4-4587-8a6d-9796b3ffd13c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Idaho Fitness Factory Victory",
      "poi_type": "Health and Wellness",
      "poi_address": "3250 S Eagle Rd, Meridian, ID 83642, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-69fc-7390-9b43-a374903227fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-69fc-7390-9b43-a374903227fa",
        "storage_key": "property/6767906449166559/019d02cf-69fc-7390-9b43-a374903227fa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://idahofitnessfactory.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8752244399493853771&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "idaho-fitness-factory-victory",
      "poi_latitude": "43.575129",
      "poi_longitude": "-116.353612",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 208-297-7949",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-b056-7788-92ff-9393c9b020c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-b056-7788-92ff-9393c9b020c6",
        "storage_key": "property/6767906449166559/019d02cf-b056-7788-92ff-9393c9b020c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX3UWQupRrlQRS7I78-g3dnk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_53ffb9cb-9155-490f-aa4c-eae53913dc0f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Tone Fitness Studio - Ten Mile",
      "poi_type": "Health and Wellness",
      "poi_address": "3064 W Milano Dr Suite 110, Meridian, ID 83646, USA",
      "poi_short_description": "Gym offering 45-minute Lagree-method classes via Megaformer machines, plus knowledgeable instructors.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-6b10-73fa-9526-160bc5d94fb4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-6b10-73fa-9526-160bc5d94fb4",
        "storage_key": "property/6767906449166559/019d02cf-6b10-73fa-9526-160bc5d94fb4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.tonefitnessstudio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4630019602986619061&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tone-fitness-studio---ten-mile",
      "poi_latitude": "43.651753",
      "poi_longitude": "-116.4318742",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 208-274-5650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-ab75-7788-bdbf-77dd40b01492.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-ab75-7788-bdbf-77dd40b01492",
        "storage_key": "property/6767906449166559/019d02cf-ab75-7788-bdbf-77dd40b01492.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmzlzEmZTrlQRtdAcS0wiQUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a0fcd5aa-8f54-49fe-8fa0-ffc664ed0860",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "HOTWORX - Meridian, ID - Ten Mile",
      "poi_type": "Health and Wellness",
      "poi_address": "3015 W McMillan Rd Suite 107, Meridian, ID 83646, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-6beb-74ef-a92b-466550941429.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-6beb-74ef-a92b-466550941429",
        "storage_key": "property/6767906449166559/019d02cf-6beb-74ef-a92b-466550941429.webp",
        "width": 550,
        "height": 551
      },
      "poi_business_url": "https://www.hotworx.net/studio/meridian-ten-mile",
      "poi_directions_map_url": "https://maps.google.com/?cid=13285654457614114983&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hotworx---meridian-id---ten-mile",
      "poi_latitude": "43.6477611",
      "poi_longitude": "-116.4311932",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 208-900-4690",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-ab75-7788-bdbf-77dd40b01492.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-ab75-7788-bdbf-77dd40b01492",
        "storage_key": "property/6767906449166559/019d02cf-ab75-7788-bdbf-77dd40b01492.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJaWPAe_lTrlQRp6CsulYgYLg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_92e12a48-0669-4304-8950-54bcba0cf622",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "YogaSix North Meridian",
      "poi_type": "Health and Wellness",
      "poi_address": "6360 N Saguaro Hills Ave, Meridian, ID 83646, USA",
      "poi_short_description": "Hot yoga studio offering a range of classes for varied benefits, including strength and balance.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-709b-7068-87ca-b5c7fb1e2591.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-709b-7068-87ca-b5c7fb1e2591",
        "storage_key": "property/6767906449166559/019d02cf-709b-7068-87ca-b5c7fb1e2591.webp",
        "width": 554,
        "height": 312
      },
      "poi_business_url": "https://www.yogasix.com/north-meridian",
      "poi_directions_map_url": "https://maps.google.com/?cid=2256680026003672986&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yogasix-north-meridian",
      "poi_latitude": "43.6624576",
      "poi_longitude": "-116.3812655",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 208-971-0238",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-ab75-7788-bdbf-77dd40b01492.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-ab75-7788-bdbf-77dd40b01492",
        "storage_key": "property/6767906449166559/019d02cf-ab75-7788-bdbf-77dd40b01492.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJu-2giMRUrlQRmg-r-YZWUR8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_4f2af63b-3cf0-42a5-9e15-5a29a633e9d5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Julius M. Kleiner Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Kleiner Memorial Pkwy, Meridian, ID 83642, USA",
      "poi_short_description": "This 58-acre park with an amphitheater offers a range of activities, such as fishing & basketball.",
      "poi_long_description": "This 58-acre park with an amphitheater offers a range of activities, such as fishing & basketball.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-538d-77b4-b12e-23f4299f7b59.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-538d-77b4-b12e-23f4299f7b59",
        "storage_key": "property/6767906449166559/019d02cf-538d-77b4-b12e-23f4299f7b59.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://meridiancity.org/parks/current-parks/julius-m-kleiner-memorial-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2582903697834749180&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "julius-m-kleiner-memorial-park",
      "poi_latitude": "43.6242178",
      "poi_longitude": "-116.3464115",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 208-888-3579",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-b06d-72d3-ad7c-65b65040a5c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-b06d-72d3-ad7c-65b65040a5c3",
        "storage_key": "property/6767906449166559/019d02cf-b06d-72d3-ad7c-65b65040a5c3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJDXe6JTlUrlQR_Kx7djpR2CM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_fb0e0b59-ca4d-4f94-a92f-ee57a7d8a42e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Discovery Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2121 E Lake Hazel Rd, Meridian, ID 83642, USA",
      "poi_short_description": "Park featuring a dog-friendly area, zip lines and a rock climbing wall, plus a splash pad.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-71fd-77d8-b45e-bd0ff9d823cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-71fd-77d8-b45e-bd0ff9d823cb",
        "storage_key": "property/6767906449166559/019d02cf-71fd-77d8-b45e-bd0ff9d823cb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://meridiancity.org/parks/current-parks/discovery-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8485930085587167758&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "discovery-park",
      "poi_latitude": "43.542614",
      "poi_longitude": "-116.3669519",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-b06d-72d3-ad7c-65b65040a5c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-b06d-72d3-ad7c-65b65040a5c3",
        "storage_key": "property/6767906449166559/019d02cf-b06d-72d3-ad7c-65b65040a5c3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJswR1KhFRrlQRDio51HMUxHU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f0884bee-cbd9-47b0-a74a-2c620589862c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Settlers' Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3245 N Meridian Rd, Meridian, ID 83646, USA",
      "poi_short_description": "Large park boasts playgrounds, baseball fields & a splash area, plus disc golf, tennis & horseshoes.",
      "poi_long_description": "Large park boasts playgrounds, baseball fields & a splash area, plus disc golf, tennis & horseshoes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-72b1-7508-8e30-5d5d5f1ba5e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-72b1-7508-8e30-5d5d5f1ba5e9",
        "storage_key": "property/6767906449166559/019d02cf-72b1-7508-8e30-5d5d5f1ba5e9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://meridiancity.org/parks/current-parks/settlers-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8799049508952512017&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "settlers-park",
      "poi_latitude": "43.6357763",
      "poi_longitude": "-116.397774",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 208-888-3579",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-b06d-72d3-ad7c-65b65040a5c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-b06d-72d3-ad7c-65b65040a5c3",
        "storage_key": "property/6767906449166559/019d02cf-b06d-72d3-ad7c-65b65040a5c3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJGYblKYBUrlQREZYwtuiAHHo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f03afbf5-22ee-445c-97c9-794e685c7545",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Storey Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "205 E Franklin Rd, Meridian, ID 83642, USA",
      "poi_short_description": "19-acre community park with softball & baseball areas, playground & large picnic shelters.",
      "poi_long_description": "19-acre community park with softball & baseball areas, playground & large picnic shelters.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-737d-7738-978f-88ab6ef7b869.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-737d-7738-978f-88ab6ef7b869",
        "storage_key": "property/6767906449166559/019d02cf-737d-7738-978f-88ab6ef7b869.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8024047195309169309&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "storey-park",
      "poi_latitude": "43.6030322",
      "poi_longitude": "-116.3884408",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 208-888-3579",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-b06d-72d3-ad7c-65b65040a5c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-b06d-72d3-ad7c-65b65040a5c3",
        "storage_key": "property/6767906449166559/019d02cf-b06d-72d3-ad7c-65b65040a5c3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJhyOyZuZTrlQRnVpfMWkkW28",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_34b03a5e-5d74-4ce2-8bc8-6d7eda59cb4f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Storey Bark Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "430 E Watertower St, Meridian, ID 83642, USA",
      "poi_short_description": "Popular fenced off-leash dog park featuring pools and grassy areas, plus two enclosures for small and large dogs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-7831-74bd-921f-243b5b31b5db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-7831-74bd-921f-243b5b31b5db",
        "storage_key": "property/6767906449166559/019d02cf-7831-74bd-921f-243b5b31b5db.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://meridiancity.org/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=14129670705395611210&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "storey-bark-park",
      "poi_latitude": "43.6011371",
      "poi_longitude": "-116.3876615",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 208-888-3579",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-b06d-72d3-ad7c-65b65040a5c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-b06d-72d3-ad7c-65b65040a5c3",
        "storage_key": "property/6767906449166559/019d02cf-b06d-72d3-ad7c-65b65040a5c3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKZc3FOFTrlQRSjZZ9KSsFsQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b8ec9088-34c2-4b5d-be73-d37208642789",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Tully Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2500 N Linder Rd, Meridian, ID 83646, USA",
      "poi_short_description": "18-acre green space with a skate park, playground & basketball court, plus picnic shelters & trails.",
      "poi_long_description": "18-acre green space with a skate park, playground & basketball court, plus picnic shelters & trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-7a15-763e-b0b9-2599a3a7fd7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-7a15-763e-b0b9-2599a3a7fd7e",
        "storage_key": "property/6767906449166559/019d02cf-7a15-763e-b0b9-2599a3a7fd7e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://meridiancity.org/parks/current-parks/tully-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8877367809808287045&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tully-park",
      "poi_latitude": "43.6272449",
      "poi_longitude": "-116.4129718",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 208-888-4433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-b06d-72d3-ad7c-65b65040a5c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-b06d-72d3-ad7c-65b65040a5c3",
        "storage_key": "property/6767906449166559/019d02cf-b06d-72d3-ad7c-65b65040a5c3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJxV7IeZ5TrlQRRUUcHP2-Mns",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_fadf18cd-1847-4d42-9797-7984693eea25",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Fuller Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3761 W Park Creek Dr, Meridian, ID 83642, USA",
      "poi_short_description": "Green space with baseball fields, a volleyball court & playground, plus pavilions & a fishing pond.",
      "poi_long_description": "Green space with baseball fields, a volleyball court & playground, plus pavilions & a fishing pond.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-7a48-7119-95a8-509941203b5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-7a48-7119-95a8-509941203b5b",
        "storage_key": "property/6767906449166559/019d02cf-7a48-7119-95a8-509941203b5b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://meridiancity.org/parks/current-parks/fuller-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1686895302179660791&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fuller-park",
      "poi_latitude": "43.61487650000001",
      "poi_longitude": "-116.4407385",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 208-888-4433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-b06d-72d3-ad7c-65b65040a5c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-b06d-72d3-ad7c-65b65040a5c3",
        "storage_key": "property/6767906449166559/019d02cf-b06d-72d3-ad7c-65b65040a5c3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJIUPvyqxTrlQR96Ox-1YOaRc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6c6a729c-04c9-49d0-9f58-7ee9275fb59f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Keith Bird Legacy Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3737 W Lost Rapids Dr, Meridian, ID 83646, USA",
      "poi_short_description": "Grassy park featuring a playground and workout area, plus a basketball court and walking path.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-7be1-71ef-be97-de8fde6046cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-7be1-71ef-be97-de8fde6046cf",
        "storage_key": "property/6767906449166559/019d02cf-7be1-71ef-be97-de8fde6046cf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://meridiancity.org/parks/current-parks/keith-bird-legacy-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1972542653464703939&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "keith-bird-legacy-park",
      "poi_latitude": "43.6589518",
      "poi_longitude": "-116.4402652",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 208-888-3579",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-b06d-72d3-ad7c-65b65040a5c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-b06d-72d3-ad7c-65b65040a5c3",
        "storage_key": "property/6767906449166559/019d02cf-b06d-72d3-ad7c-65b65040a5c3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJPUM2jE1TrlQRw_MRpBfhXxs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_18296f50-288b-452f-9985-d58d873e1fbb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Bernadine Quinn Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "361 N Whitewater Park Blvd Q302, Boise, ID 83702, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-8177-7720-baa5-5872287aa5c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-8177-7720-baa5-5872287aa5c5",
        "storage_key": "property/6767906449166559/019d02cf-8177-7720-baa5-5872287aa5c5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13694702403456657168&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bernadine-quinn-park",
      "poi_latitude": "43.622396",
      "poi_longitude": "-116.2324719",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-b06d-72d3-ad7c-65b65040a5c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-b06d-72d3-ad7c-65b65040a5c3",
        "storage_key": "property/6767906449166559/019d02cf-b06d-72d3-ad7c-65b65040a5c3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJWxQvvH_5rlQREOe4PkdbDb4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2164fdb5-5eaf-4f5a-b489-979021378bbc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "The WaterShed",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11818 Joplin Rd, Ancell Ave Entrance B, Boise, ID 83714, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-8201-76bc-a5f7-e47a3b59da01.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-8201-76bc-a5f7-e47a3b59da01",
        "storage_key": "property/6767906449166559/019d02cf-8201-76bc-a5f7-e47a3b59da01.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "https://www.boisewatershed.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9452201134787987356&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-watershed",
      "poi_latitude": "43.6672298",
      "poi_longitude": "-116.3296504",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 208-608-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-ab75-7788-bdbf-77dd40b01492.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-ab75-7788-bdbf-77dd40b01492",
        "storage_key": "property/6767906449166559/019d02cf-ab75-7788-bdbf-77dd40b01492.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJX0FyDd5VrlQRnAeVKNr2LIM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4c992ff6-74d0-4c04-b23b-7ac6efed5bb4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Ten Mile Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "3047 W Overland Rd, Meridian, ID 83642, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-8255-71fb-a34b-14cf7dcf4ee9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-8255-71fb-a34b-14cf7dcf4ee9",
        "storage_key": "property/6767906449166559/019d02cf-8255-71fb-a34b-14cf7dcf4ee9.webp",
        "width": 1280,
        "height": 562
      },
      "poi_business_url": "https://www.commuteride.com/clubred",
      "poi_directions_map_url": "https://maps.google.com/?cid=11767849884057238491&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ten-mile-park-and-ride",
      "poi_latitude": "43.5846909",
      "poi_longitude": "-116.4332996",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 208-345-7665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-b602-72ac-baee-3bf148a43192.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-b602-72ac-baee-3bf148a43192",
        "storage_key": "property/6767906449166559/019d02cf-b602-72ac-baee-3bf148a43192.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6ReKQIpRrlQR23ta7R7NT6M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_f1269860-b510-4252-af73-5121921d3809",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Transportation & Transit",
      "poi_address": "305 W Overland Rd, Meridian, ID 83642, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-8266-7680-9d43-82de06e7bb00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-8266-7680-9d43-82de06e7bb00",
        "storage_key": "property/6767906449166559/019d02cf-8266-7680-9d43-82de06e7bb00.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/ID-Meridian/2792?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-2792-_-na-_-0-_-0&y_source=1_MTE4MjgzNy03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=4825086452542712550&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "43.5888824",
      "poi_longitude": "-116.3975524",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 208-855-5160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-ab72-7318-89d6-cb4328a5bf41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-ab72-7318-89d6-cb4328a5bf41",
        "storage_key": "property/6767906449166559/019d02cf-ab72-7318-89d6-cb4328a5bf41.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ6b3OZ2RRrlQR5qpbbpAm9kI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_57736ac1-0dab-4960-934f-3e03e116ccd8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Interstate 84",
      "poi_type": "Transportation & Transit",
      "poi_address": "I-84, United States",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-8a1d-7297-ba19-0dae4d983c5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-8a1d-7297-ba19-0dae4d983c5e",
        "storage_key": "property/6767906449166559/019d02cf-8a1d-7297-ba19-0dae4d983c5e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6401954630463137450&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "interstate-84",
      "poi_latitude": "43.6420154",
      "poi_longitude": "-116.6453737",
      "poi_miles_from_property": "16.1",
      "poi_walking_minutes": "5 hours 51 mins",
      "poi_biking_minutes": "1 hour 23 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-b056-7788-92ff-9393c9b020c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-b056-7788-92ff-9393c9b020c6",
        "storage_key": "property/6767906449166559/019d02cf-b056-7788-92ff-9393c9b020c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFTfjBDvWsVQRqibsQNFP2Fg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c44e3cd0-2d4e-4b1d-845a-c5795493794d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Valley Regional Transit: Administrative Office",
      "poi_type": "Transportation & Transit",
      "poi_address": "700 NE 2nd St, Meridian, ID 83642, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-8af5-7754-9513-8c21be33740e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-8af5-7754-9513-8c21be33740e",
        "storage_key": "property/6767906449166559/019d02cf-8af5-7754-9513-8c21be33740e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.valleyregionaltransit.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11953795838185254116&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valley-regional-transit-administrative-office",
      "poi_latitude": "43.6103639",
      "poi_longitude": "-116.389868",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 208-345-7433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-b056-7788-92ff-9393c9b020c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-b056-7788-92ff-9393c9b020c6",
        "storage_key": "property/6767906449166559/019d02cf-b056-7788-92ff-9393c9b020c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_VqPxO1TrlQR5CyTHPtp5KU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_024d0e0a-9d22-4499-b012-4fed02d46858",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Main Street Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "777 W Main St, Boise, ID 83702, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-8a8a-73bd-951f-eedf209b9f8f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-8a8a-73bd-951f-eedf209b9f8f",
        "storage_key": "property/6767906449166559/019d02cf-8a8a-73bd-951f-eedf209b9f8f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.valleyregionaltransit.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16608178742008414868&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "main-street-station",
      "poi_latitude": "43.615036",
      "poi_longitude": "-116.2036895",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 208-345-7433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-b056-7788-92ff-9393c9b020c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-b056-7788-92ff-9393c9b020c6",
        "storage_key": "property/6767906449166559/019d02cf-b056-7788-92ff-9393c9b020c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm-fs6OT4rlQRlAKba5IafOY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9d82e977-9311-4c72-8efe-07e50e250e2c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Boise Towne Square",
      "poi_type": "Transportation & Transit",
      "poi_address": "350 N Milwaukee St, Boise, ID 83704, USA",
      "poi_short_description": "Mellow, spacious mall housing over 180 shops, including department stores & casual restaurants.",
      "poi_long_description": "Mellow, spacious mall housing over 180 shops, including department stores & casual restaurants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-8adc-718b-989c-e77613594e8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-8adc-718b-989c-e77613594e8b",
        "storage_key": "property/6767906449166559/019d02cf-8adc-718b-989c-e77613594e8b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.boisetownesquare.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=6261565970256386638&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boise-towne-square",
      "poi_latitude": "43.6073835",
      "poi_longitude": "-116.2789224",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 208-639-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-ab72-7318-89d6-cb4328a5bf41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-ab72-7318-89d6-cb4328a5bf41",
        "storage_key": "property/6767906449166559/019d02cf-ab72-7318-89d6-cb4328a5bf41.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJWyq6WmtWrlQRTlrOIhON5VY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_62775501-bd1e-4610-96c1-ad9082130728",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "College of Western Idaho",
      "poi_type": "Transportation & Transit",
      "poi_address": "5500 E Opportunity Dr, Nampa, ID 83687, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-9196-73be-a30e-2f8662b79a57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-9196-73be-a30e-2f8662b79a57",
        "storage_key": "property/6767906449166559/019d02cf-9196-73be-a30e-2f8662b79a57.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://cwi.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13959056324980118248&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "college-of-western-idaho",
      "poi_latitude": "43.6140899",
      "poi_longitude": "-116.5072495",
      "poi_miles_from_property": "9.4",
      "poi_walking_minutes": "3 hours 26 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 208-562-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-ab75-7788-bdbf-77dd40b01492.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-ab75-7788-bdbf-77dd40b01492",
        "storage_key": "property/6767906449166559/019d02cf-ab75-7788-bdbf-77dd40b01492.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJR7RBnHxNrlQR6BIc8sSHuME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_f90d04c7-7aeb-49d2-8b0d-89847018c5fe",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Boise Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "3201 W Airport Way #1000, Boise, ID 83705, USA",
      "poi_short_description": "This modest airport offering flights to some major U.S. cities features an array of artwork.",
      "poi_long_description": "This modest airport offering flights to some major U.S. cities features an array of artwork.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-925a-724c-8a20-6abd0593a77d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-925a-724c-8a20-6abd0593a77d",
        "storage_key": "property/6767906449166559/019d02cf-925a-724c-8a20-6abd0593a77d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.iflyboise.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10290408102195936811&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boise-airport",
      "poi_latitude": "43.56094909999999",
      "poi_longitude": "-116.2174493",
      "poi_miles_from_property": "9.8",
      "poi_walking_minutes": "3 hours 38 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 208-383-3110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-b5f8-7418-ae33-7e808a26f48d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-b5f8-7418-ae33-7e808a26f48d",
        "storage_key": "property/6767906449166559/019d02cf-b5f8-7418-ae33-7e808a26f48d.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJRxv4IfdXrlQRK74w5aXfzo4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_53d7d371-7d99-4929-9934-bc86273bf057",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Micron Semiconductor Products Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3475 E Commercial St, Meridian, ID 83642, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://micron.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4044247650564181817&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "micron-semiconductor-products-inc",
      "poi_latitude": "43.6092999",
      "poi_longitude": "-116.3507911",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 208-363-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-b056-7788-92ff-9393c9b020c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-b056-7788-92ff-9393c9b020c6",
        "storage_key": "property/6767906449166559/019d02cf-b056-7788-92ff-9393c9b020c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFQdFSxxUrlQROQ-Wk88NIDg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0ecb0703-6aff-49d7-a9ae-81e164ad5fc7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Saint Alphonsus Family Medicine Meridian Health Plaza",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3025 W Cherry Ln B, Meridian, ID 83642, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-9257-706d-9cf7-ba441499991d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-9257-706d-9cf7-ba441499991d",
        "storage_key": "property/6767906449166559/019d02cf-9257-706d-9cf7-ba441499991d.webp",
        "width": 500,
        "height": 500
      },
      "poi_business_url": "https://www.saintalphonsus.org/location/saint-alphonsus-family-medicine-mhp?utm_source=gmb&utm_medium=organic&utm_campaign=gmb&utm_content=main_link",
      "poi_directions_map_url": "https://maps.google.com/?cid=5070016371499210303&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-alphonsus-family-medicine-meridian-health-plaza",
      "poi_latitude": "43.6186629",
      "poi_longitude": "-116.4306666",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 208-302-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-b056-7788-92ff-9393c9b020c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-b056-7788-92ff-9393c9b020c6",
        "storage_key": "property/6767906449166559/019d02cf-b056-7788-92ff-9393c9b020c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc0s15K5TrlQRPxagHAdRXEY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "doctor"
    },
    {
      "id": "custom_bd6409e4-c376-47b5-b770-db2dd7cfa56a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Meridian City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "33 E Broadway Ave, Meridian, ID 83642, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-9321-732f-9563-7c9a5024023f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-9321-732f-9563-7c9a5024023f",
        "storage_key": "property/6767906449166559/019d02cf-9321-732f-9563-7c9a5024023f.webp",
        "width": 1280,
        "height": 734
      },
      "poi_business_url": "http://www.meridiancity.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8391587334017330022&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meridian-city-hall",
      "poi_latitude": "43.6096694",
      "poi_longitude": "-116.3931756",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 208-888-4433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-b648-717c-8a86-c55bd1f53fa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-b648-717c-8a86-c55bd1f53fa8",
        "storage_key": "property/6767906449166559/019d02cf-b648-717c-8a86-c55bd1f53fa8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk6kdv-5TrlQRZivFQTjodHQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_9a6a8731-c5f3-4fae-8545-829892571242",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Boise VA Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "500 W Fort St, Boise, ID 83702, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-98f1-769f-bc44-11ba2f278225.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-98f1-769f-bc44-11ba2f278225",
        "storage_key": "property/6767906449166559/019d02cf-98f1-769f-bc44-11ba2f278225.webp",
        "width": 900,
        "height": 603
      },
      "poi_business_url": "http://www.boise.va.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10485423243127549126&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boise-va-medical-center",
      "poi_latitude": "43.6209795",
      "poi_longitude": "-116.1898311",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 11 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 208-422-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-b648-717c-8a86-c55bd1f53fa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-b648-717c-8a86-c55bd1f53fa8",
        "storage_key": "property/6767906449166559/019d02cf-b648-717c-8a86-c55bd1f53fa8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8frwuh35rlQRxuw9ruK0g5E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_c38b8c4f-a6ee-4f92-bf64-db679d73718e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Liberal Arts Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Liberal Arts Building, 1910 W University Dr, Boise, ID 83725, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-9992-7622-888a-59a5292390a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-9992-7622-888a-59a5292390a5",
        "storage_key": "property/6767906449166559/019d02cf-9992-7622-888a-59a5292390a5.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16592953031482519827&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "liberal-arts-building",
      "poi_latitude": "43.6033151",
      "poi_longitude": "-116.2032991",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-b056-7788-92ff-9393c9b020c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-b056-7788-92ff-9393c9b020c6",
        "storage_key": "property/6767906449166559/019d02cf-b056-7788-92ff-9393c9b020c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ430Tulj4rlQRE7FBcN4CRuY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "premise"
    },
    {
      "id": "custom_77aae7ee-cbdb-44b8-8fcb-49ecfec58634",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Micron Technology",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8000 S Federal Way, Boise, ID 83716, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-9992-7622-888a-54503549daa7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-9992-7622-888a-54503549daa7",
        "storage_key": "property/6767906449166559/019d02cf-9992-7622-888a-54503549daa7.webp",
        "width": 1280,
        "height": 320
      },
      "poi_business_url": "https://www.micron.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=109750950615189741&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "micron-technology",
      "poi_latitude": "43.5306658",
      "poi_longitude": "-116.1504033",
      "poi_miles_from_property": "13.4",
      "poi_walking_minutes": "5 hours 1 min",
      "poi_biking_minutes": "1 hour 24 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 208-368-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-b056-7788-92ff-9393c9b020c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-b056-7788-92ff-9393c9b020c6",
        "storage_key": "property/6767906449166559/019d02cf-b056-7788-92ff-9393c9b020c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx0G3DDr2rlQR7QgueejphQE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4bb7a8cc-dfba-489b-9a55-11261f56915d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Albertsons Companies Corporate Office Boise",
      "poi_type": "Major Employers & Offices",
      "poi_address": "250 E Parkcenter Blvd, Boise, ID 83706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-9a55-72ac-b51e-22c467bd93cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-9a55-72ac-b51e-22c467bd93cf",
        "storage_key": "property/6767906449166559/019d02cf-9a55-72ac-b51e-22c467bd93cf.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.albertsonscompanies.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15859363703725902221&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "albertsons-companies-corporate-office-boise",
      "poi_latitude": "43.5993432",
      "poi_longitude": "-116.1803514",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "3 hours 26 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 877-723-3929",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-a645-76fb-8a01-006cd4dcf968.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-a645-76fb-8a01-006cd4dcf968",
        "storage_key": "property/6767906449166559/019d02cf-a645-76fb-8a01-006cd4dcf968.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ84zHTn5rlQRjUlOFEPHF9w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_35d16682-456e-4e58-872c-97c67d9815c9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Simplot World Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1099 W Front St, Boise, ID 83702, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-9fb0-769e-b0d2-ccf5c83bb5a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-9fb0-769e-b0d2-ccf5c83bb5a9",
        "storage_key": "property/6767906449166559/019d02cf-9fb0-769e-b0d2-ccf5c83bb5a9.webp",
        "width": 1280,
        "height": 307
      },
      "poi_business_url": "http://www.simplot.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9891362728269285182&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "simplot-world-headquarters",
      "poi_latitude": "43.6155069",
      "poi_longitude": "-116.2082845",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 208-336-2110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-b056-7788-92ff-9393c9b020c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-b056-7788-92ff-9393c9b020c6",
        "storage_key": "property/6767906449166559/019d02cf-b056-7788-92ff-9393c9b020c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYfCyiOX4rlQRPocHo_4tRYk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_764ea866-cb76-411a-9361-74f0a8ee0dd3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "custom",
      "poi_name": "Ada County Courthouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "200 W Front St, Boise, ID 83702, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-a091-72bc-8015-a166ad4f8f0d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-a091-72bc-8015-a166ad4f8f0d",
        "storage_key": "property/6767906449166559/019d02cf-a091-72bc-8015-a166ad4f8f0d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://adacounty.id.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5024626471509498433&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ada-county-courthouse",
      "poi_latitude": "43.6106019",
      "poi_longitude": "-116.1974242",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 208-287-6900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-b648-717c-8a86-c55bd1f53fa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-b648-717c-8a86-c55bd1f53fa8",
        "storage_key": "property/6767906449166559/019d02cf-b648-717c-8a86-c55bd1f53fa8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsfvFWfn4rlQRQRpZeycPu0U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_6143fe6dd51091f06d44cf99",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_5d353a33158c133e86510a47",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_5a73f0c34a47ea4e4d265f40",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_01bcd38c7f5b0f6a2ece159c",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_aff4864b0245f44698ed2b7a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "ec_c62d86ef3fa8fb579fd29904",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "rating": "5",
      "name": "Christy Wright",
      "text": "I just moved back to the Boise area after moving to another state in 2013. It is great to be back! I love this area, (Meridian),  and Stonesthrow Townhomes are wonderful! The management are friendly and go out of their way to help, as does the maintenance team. The grounds are perfectly manicured, the buildings are well kept, it is just what I was hoping for! If you are in the market to make a move don't pass up Stonesthrow!",
      "date": "2025-11-21",
      "title": "false"
    },
    {
      "id": "ec_0329ecd90c9967637c2d4cfb",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "rating": "5",
      "name": "N Will",
      "text": "I’ve loved living here. The neighborhood is generally quiet, the maintenance guys are quick to respond to issues, and Kloe has been a pleasure to work with. My only complaint is that there are only two treadmills in the gym, so it can be kind of annoying when both are being used. Other than that, the amenities are great too.",
      "date": "2025-11-11",
      "title": "false"
    },
    {
      "id": "ec_b603be0634e9339b9ddf5de6",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "rating": "5",
      "name": "Gabby Dewaele",
      "text": "I’ve lived at Stonesthrow for about four years now, and the maintenance team is always amazing! They’re friendly, funny, and just super swell people all around. No matter how busy they are, they respond fast and always get things taken care of. Definitely a 10/10 crew — they never disappoint!",
      "date": "2025-11-06",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a5033-e544-702e-ba25-db1dddd7803c",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "amc-cottages-at-stonesthrow",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "generator",
      "page_item_url": "dog-park-apartments-meridian-id",
      "search_query": "dog park apartments Meridian ID",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in Meridian, ID",
      "h2_subtitle": "Discover dog-friendly apartments in Meridian, ID with spacious areas. Cottages at Stonesthrow offers more than just living spaces, it’s a community for you and your pet.",
      "page_copy": "Nestled in the charming city of Meridian, ID, the Cottages at Stonesthrow provide the perfect home for pet lovers. Our community stands out with its very own dog park, allowing your furry friends ample space to play and explore. Beyond our pet-friendly perks, residents enjoy the comfort of spacious two- and three-bedroom apartments, elegantly designed with features like vaulted ceilings and hardwood floors.\n\nThe Cottages at Stonesthrow aren’t just about homes; they’re about creating a lifestyle. With door-to-door trash pickup and a welcoming clubhouse, convenience, and camaraderie blend beautifully here. If you’re searching for dog park apartments in Meridian, ID, look no further. Your vibrant new life here awaits, where your pet feels as much at home as you do.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
      "featured_image_media": {
        "alt_text": "Stone Throw community sign with windmill and clubhouse in background.",
        "public_id": "019d02cf-0015-745f-8329-5657ae2904ba",
        "storage_key": "property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
        "width": 1037,
        "height": 691
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in Meridian, ID",
      "seo_description": "Explore dog park apartments in Meridian, ID at Cottages at Stonesthrow. Spacious homes with a dog park await you and your furry friend.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "generator",
      "page_item_url": "vaulted-ceiling-apartments-ada-county",
      "search_query": "vaulted ceiling apartments Ada County",
      "category": "Amenity",
      "h1_title": "Vaulted Ceiling Apartments in Ada County",
      "h2_subtitle": "Discover stunning vaulted ceiling apartments in Ada County. Experience the elevated living spaces at Cottages at Stonesthrow in Meridian, ID.",
      "page_copy": "Looking for that touch of elegance in your next home? The Cottages at Stonesthrow in Ada County offer exquisite vaulted ceiling apartments that redefine spaciousness and style. These architectural features not only enhance the aesthetic appeal of our two- and three-bedroom apartments but also create a haven of openness and light, making them a sought-after choice for discerning renters.\n\nSituated in vibrant Meridian, ID, the amenities at Cottages at Stonesthrow extend beyond breathtaking interiors. Enjoy community features like a modern clubhouse, a serene dog park, and practical comforts such as linen closets and door-to-door trash services. If you desire vaulted ceiling apartments in Ada County, let the Cottages at Stonesthrow be your next home, blending beauty and functionality perfectly.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
      "featured_image_media": {
        "alt_text": "Stone Throw community sign with windmill and clubhouse in background.",
        "public_id": "019d02cf-0015-745f-8329-5657ae2904ba",
        "storage_key": "property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
        "width": 1037,
        "height": 691
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Vaulted Ceiling Apartments in Ada County",
      "seo_description": "Explore vaulted ceiling apartments in Ada County at Cottages at Stonesthrow. Discover style and spacious living in Meridian, ID.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "generator",
      "page_item_url": "hardwood-floor-apartments-west-boise",
      "search_query": "hardwood floor apartments West Boise",
      "category": "Amenity",
      "h1_title": "Hardwood Floor Apartments in West Boise",
      "h2_subtitle": "Explore elegant hardwood floor apartments in West Boise. Cottages at Stonesthrow offers stylish living with beautiful finishes in Meridian, ID.",
      "page_copy": "Step into a world of sophistication with the Cottages at Stonesthrow, where hardwood floors grace each apartment in this dynamic community near West Boise. Our two- and three-bedroom units elevate everyday living with their elegant flooring, bringing both style and durability to your home. This touch of class complements the welcoming atmosphere you’ll feel as soon as you arrive.\n\nLocated conveniently in Meridian, ID, this sought-after neighborhood offers more than just beautiful interiors. Residents at the Cottages at Stonesthrow enjoy amenities including a community clubhouse, a dog park, and in-home conveniences like a linen closet and modern kitchen appliances. If you’re searching for hardwood floor apartments near West Boise, our community awaits you with open doors and a warm welcome.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
      "featured_image_media": {
        "alt_text": "Stone Throw community sign with windmill and clubhouse in background.",
        "public_id": "019d02cf-0015-745f-8329-5657ae2904ba",
        "storage_key": "property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
        "width": 1037,
        "height": 691
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Hardwood Floor Apartments in West Boise",
      "seo_description": "Discover hardwood floor apartments in West Boise at Cottages at Stonesthrow. Enjoy stylish living with quality finishes in Meridian, ID.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "generator",
      "page_item_url": "clubhouse-apartments-83642",
      "search_query": "clubhouse apartments 83642",
      "category": "Amenity",
      "h1_title": "Clubhouse Apartments in 83642",
      "h2_subtitle": "Discover clubhouse apartments in the 83642 area at Cottages at Stonesthrow. Enjoy an inviting community and upscale living in Meridian, ID.",
      "page_copy": "Experience the inviting community lifestyle at Cottages at Stonesthrow, proudly featuring clubhouse apartments in the 83642 area. Our stylish and spacious two- and three-bedroom units come with a range of perks, including the use of a modern clubhouse—perfect for hosting events or simply relaxing with fellow residents. This amenity enhances social connections, providing a welcoming hub at the heart of our Meridian apartments.\n\nNestled in the vibrant west side of Meridian, ID, our prestigious community doesn’t just stop at social spaces. With added features like a dog park, convenient door-to-door trash pickup, and elegant interiors with vaulted ceilings and hardwood floors, living at Cottages at Stonesthrow is both comfortable and convenient. Choose our clubhouse apartments in 83642 for a well-rounded living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
      "featured_image_media": {
        "alt_text": "Stone Throw community sign with windmill and clubhouse in background.",
        "public_id": "019d02cf-0015-745f-8329-5657ae2904ba",
        "storage_key": "property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
        "width": 1037,
        "height": 691
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Clubhouse Apartments in 83642",
      "seo_description": "Explore clubhouse apartments in the 83642 area at Cottages at Stonesthrow. Enjoy a vibrant community lifestyle in Meridian, ID.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "generator",
      "page_item_url": "island-kitchen-apartments-meridian",
      "search_query": "island kitchen apartments Meridian",
      "category": "Amenity",
      "h1_title": "Island Kitchen Apartments in Meridian",
      "h2_subtitle": "Find island kitchen apartments in Meridian at Cottages at Stonesthrow. Experience modern living with stylish amenities in a vibrant community.",
      "page_copy": "Discover the perfect blend of style and function with our island kitchen apartments in Meridian, available at the Cottages at Stonesthrow. These kitchens are thoughtfully designed to enhance your culinary experience, offering a central hub for dining, entertaining, and family gatherings. The spacious layout of our two- and three-bedroom apartments ensures you have ample room for hosting friends or simply enjoying an evening in.\n\nLocated in the thriving city of Meridian, ID, the Cottages at Stonesthrow provides more than beautiful kitchens. Residents enjoy a suite of enticing amenities, from a community clubhouse and a comfortable living area with vaulted ceilings to a dog park and modern conveniences like a linen closet and range. If an island kitchen is on your list, our Meridian apartments are ready to welcome you home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
      "featured_image_media": {
        "alt_text": "Stone Throw community sign with windmill and clubhouse in background.",
        "public_id": "019d02cf-0015-745f-8329-5657ae2904ba",
        "storage_key": "property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
        "width": 1037,
        "height": 691
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Island Kitchen Apartments in Meridian",
      "seo_description": "Discover island kitchen apartments in Meridian at Cottages at Stonesthrow. Enjoy modern living in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-meridian-id",
      "search_query": "two bedroom apartments meridian id",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Meridian, ID",
      "h2_subtitle": "Explore spacious two bedroom apartments in Meridian, ID at Cottages at Stonesthrow. Enjoy modern amenities and a community atmosphere.",
      "page_copy": "Cottages at Stonesthrow offers spacious two bedroom apartments in Meridian, ID, designed to enhance your living experience. Our apartments provide generous living spaces complemented by features like vaulted ceilings and beautiful hardwood floors, perfect for creating a comfortable and inviting home.\n\nLocated in the heart of Meridian, Cottages at Stonesthrow is more than just a place to live; it's a vibrant community. Residents have access to top-notch amenities, including a welcoming clubhouse, dog park, and convenient utility features like a linen closet and walk-up access. These two bedroom apartments offer both convenience and style, making them a perfect choice for anyone looking to settle in Meridian, ID.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
      "featured_image_media": {
        "alt_text": "Stone Throw community sign with windmill and clubhouse in background.",
        "public_id": "019d02cf-0015-745f-8329-5657ae2904ba",
        "storage_key": "property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
        "width": 1037,
        "height": 691
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Meridian, ID",
      "seo_description": "Find two bedroom apartments in Meridian, ID at Cottages at Stonesthrow. Enjoy spacious living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-ada-county",
      "search_query": "three bedroom apartments ada county",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Ada County",
      "h2_subtitle": "Discover spacious three bedroom apartments in Ada County at Cottages at Stonesthrow. Enjoy luxury living in a vibrant community setting.",
      "page_copy": "For families or those needing extra space, the three bedroom apartments in Ada County at Cottages at Stonesthrow offer an ideal solution. These well-appointed apartments provide ample room for living, working, and entertaining, featuring stylish touches such as vaulted ceilings and elegant hardwood floors.\n\nNestled in the thriving community of Meridian, ID, our residences are more than just about spacious living. At Cottages at Stonesthrow, enjoy a host of amenities, including a welcoming clubhouse, an expansive dog park, and convenient features like a linen closet and range. These three bedroom apartments are perfectly situated in Ada County, providing residents with a vibrant community atmosphere and easy access to the best local offerings.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
      "featured_image_media": {
        "alt_text": "Stone Throw community sign with windmill and clubhouse in background.",
        "public_id": "019d02cf-0015-745f-8329-5657ae2904ba",
        "storage_key": "property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
        "width": 1037,
        "height": 691
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Ada County",
      "seo_description": "Find spacious three bedroom apartments in Ada County at Cottages at Stonesthrow. Enjoy modern amenities in a community-focused setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "generator",
      "page_item_url": "apartments-near-lewis-clark-middle-school-meridian-id",
      "search_query": "apartments near lewis & clark middle school meridian id",
      "category": "School",
      "h1_title": "Apartments Near Lewis & Clark Middle School",
      "h2_subtitle": "Discover convenient living in Meridian with apartments near Lewis & Clark Middle School. Cottages at Stonesthrow offers comfort and community close by.",
      "page_copy": "Looking for the perfect home near Lewis & Clark Middle School in Meridian, ID? Cottages at Stonesthrow offers a community of welcoming apartments that are just a short distance from the school. Our two- and three-bedroom options provide ample space and are designed with stylish features such as vaulted ceilings and hardwood floors.\n\nLiving at Cottages at Stonesthrow means enjoying a vibrant community atmosphere with access to premium amenities including a modern clubhouse and an inviting dog park. Practical conveniences like a linen closet and door-to-door trash pickup make life even more comfortable. Choose our apartments near Lewis & Clark Middle School for a blend of proximity, comfort, and a fantastic community vibe.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
      "featured_image_media": {
        "alt_text": "Stone Throw community sign with windmill and clubhouse in background.",
        "public_id": "019d02cf-0015-745f-8329-5657ae2904ba",
        "storage_key": "property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
        "width": 1037,
        "height": 691
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Lewis & Clark Middle School",
      "seo_description": "Find apartments near Lewis & Clark Middle School in Meridian, ID at Cottages at Stonesthrow. Enjoy comfortable living close to educational excellence.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "generator",
      "page_item_url": "cottages-at-stonesthrow-near-meridian-middle-school",
      "search_query": "cottages at stonesthrow near meridian middle school",
      "category": "School",
      "h1_title": "Cottages at Stonesthrow: Close to Meridian Middle",
      "h2_subtitle": "Discover Cottages at Stonesthrow, located near Meridian Middle School. Enjoy a vibrant community with modern amenities just minutes away.",
      "page_copy": "Cottages at Stonesthrow offers an ideal location for those seeking proximity to Meridian Middle School. Our community provides a range of spacious two- and three-bedroom apartments that feature elegant hardwood floors and vaulted ceilings, ensuring a stylish and comfortable living space.\n\nSituated in the lively area of Meridian, ID, Cottages at Stonesthrow is more than just residences; it's a community enriched with amenities. Enjoy the clubhouse for social gatherings, let your furry friend roam free in the dog park, and take advantage of convenient features like door-to-door trash pickup. Perfectly positioned near Meridian Middle School, Cottages at Stonesthrow combines convenience with a vibrant community atmosphere.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
      "featured_image_media": {
        "alt_text": "Stone Throw community sign with windmill and clubhouse in background.",
        "public_id": "019d02cf-0015-745f-8329-5657ae2904ba",
        "storage_key": "property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
        "width": 1037,
        "height": 691
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cottages at Stonesthrow Near Meridian Middle",
      "seo_description": "Cottages at Stonesthrow offers spacious living near Meridian Middle School. Enjoy a community with modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "generator",
      "page_item_url": "living-close-to-meridian-elementary-school-ada-county",
      "search_query": "living close to meridian elementary school ada county",
      "category": "School",
      "h1_title": "Living Close to Meridian Elementary School",
      "h2_subtitle": "Experience life close to Meridian Elementary School in Ada County at Cottages at Stonesthrow. Enjoy a family-friendly community with modern amenities.",
      "page_copy": "Finding the perfect home near Meridian Elementary School in Ada County is easy with Cottages at Stonesthrow. Our two- and three-bedroom apartments offer a welcoming environment for families looking to settle close to excellent schools. With vaulted ceilings and hardwood floors, each apartment blends style with comfort.\n\nLocated in the heart of Meridian, ID, Cottages at Stonesthrow is more than just a place to live; it's a community. With amenities like a dog park and a spacious clubhouse, residents enjoy a vibrant neighborhood atmosphere. Practical features such as a linen closet and walk-up accessibility add to the convenience of living here. Choose Cottages at Stonesthrow for a family-friendly community close to Meridian Elementary School in Ada County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
      "featured_image_media": {
        "alt_text": "Stone Throw community sign with windmill and clubhouse in background.",
        "public_id": "019d02cf-0015-745f-8329-5657ae2904ba",
        "storage_key": "property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
        "width": 1037,
        "height": 691
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Close to Meridian Elementary School",
      "seo_description": "Cottages at Stonesthrow offers family-friendly living close to Meridian Elementary School in Ada County. Enjoy a vibrant community and modern comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "generator",
      "page_item_url": "discovery-elementary-school-area-apartments",
      "search_query": "discovery elementary school area apartments",
      "category": "School",
      "h1_title": "Apartments Near Discovery Elementary School",
      "h2_subtitle": "Explore spacious apartments in the Discovery Elementary School area. Cottages at Stonesthrow is your gateway to comfortable living in a vibrant community.",
      "page_copy": "If you're searching for a home near Discovery Elementary School, Cottages at Stonesthrow provides an excellent choice. Our community, located in Meridian, ID, features spacious two- and three-bedroom apartments that are perfect for families. Hardwood floors and vaulted ceilings give each residence a touch of elegance.\n\nCottages at Stonesthrow not only provides easy access to Discovery Elementary School but also offers a range of amenities. Our clubhouse and dog park enhance the community feel, while conveniences like a linen closet and door-to-door trash pickup simplify daily living. Enjoy being part of a welcoming neighborhood with all the comforts you need, close to educational opportunities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
      "featured_image_media": {
        "alt_text": "Stone Throw community sign with windmill and clubhouse in background.",
        "public_id": "019d02cf-0015-745f-8329-5657ae2904ba",
        "storage_key": "property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
        "width": 1037,
        "height": 691
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Discovery Elementary School",
      "seo_description": "Find comfortable living at Cottages at Stonesthrow, close to Discovery Elementary School. Enjoy spacious apartments and a friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "generator",
      "page_item_url": "ustick-elementary-school-nearby-rentals",
      "search_query": "ustick elementary school nearby rentals",
      "category": "School",
      "h1_title": "Rentals Near Ustick Elementary School",
      "h2_subtitle": "Discover convenient rentals near Ustick Elementary School at Cottages at Stonesthrow. Enjoy a community with modern amenities and a welcoming environment.",
      "page_copy": "Cottages at Stonesthrow offers exceptional rental opportunities for those seeking proximity to Ustick Elementary School. Nestled in Meridian, ID, our community presents two- and three-bedroom apartments that cater to families and individuals alike. Featuring hardwood floors and vaulted ceilings, our residences provide both comfort and elegance.\n\nLiving at Cottages at Stonesthrow means more than just a great location. Our amenities include a dog park, a lively clubhouse, and practical features such as a linen closet and convenient walk-up access. The vibrant community atmosphere and modern conveniences make Cottages at Stonesthrow the perfect choice for anyone seeking rentals near Ustick Elementary School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
      "featured_image_media": {
        "alt_text": "Stone Throw community sign with windmill and clubhouse in background.",
        "public_id": "019d02cf-0015-745f-8329-5657ae2904ba",
        "storage_key": "property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
        "width": 1037,
        "height": 691
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Ustick Elementary School",
      "seo_description": "Cottages at Stonesthrow offers rentals near Ustick Elementary School. Enjoy spacious living and modern amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "generator",
      "page_item_url": "meridian-high-school-proximate-apartments",
      "search_query": "meridian high school proximate apartments",
      "category": "School",
      "h1_title": "Apartments Near Meridian High School",
      "h2_subtitle": "Find proximate apartments to Meridian High School at Cottages at Stonesthrow. Enjoy a supportive community with family-friendly features.",
      "page_copy": "Looking for apartments close to Meridian High School? Cottages at Stonesthrow is ideally positioned in Meridian, ID, offering spacious two- and three-bedroom apartments perfect for families. With vaulted ceilings and beautiful hardwood floors, our homes provide a stylish yet comfortable living space.\n\nResidents benefit from close proximity to Meridian High School and enjoy a wealth of amenities that enhance everyday life. The community features a clubhouse, dog park, and practical conveniences like a walk-up design and door-to-door trash pickup. Whether you're a family or an individual seeking an engaging community, Cottages at Stonesthrow brings modern comfort near Meridian High School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
      "featured_image_media": {
        "alt_text": "Stone Throw community sign with windmill and clubhouse in background.",
        "public_id": "019d02cf-0015-745f-8329-5657ae2904ba",
        "storage_key": "property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
        "width": 1037,
        "height": 691
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Meridian High School",
      "seo_description": "Discover comfort at Cottages at Stonesthrow, offering apartments near Meridian High School. Enjoy a family-friendly, amenity-rich community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "generator",
      "page_item_url": "apartments-close-to-northwest-nazarene-university-nampa-id",
      "search_query": "apartments close to northwest nazarene university nampa id",
      "category": "School",
      "h1_title": "Apartments Near Northwest Nazarene University",
      "h2_subtitle": "Explore spacious apartments close to Northwest Nazarene University in Nampa, ID. Cottages at Stonesthrow offers a vibrant community and modern amenities.",
      "page_copy": "For those seeking apartments near Northwest Nazarene University in Nampa, ID, Cottages at Stonesthrow is an excellent choice. Situated in nearby Meridian, our community offers expansive two- and three-bedroom apartments designed with your lifestyle in mind. Enjoy the elegance of vaulted ceilings and the warmth of hardwood floors.\n\nJust a short drive away from Northwest Nazarene University, Cottages at Stonesthrow provides more than just a convenient location. Our residents can take advantage of a welcoming clubhouse, a dog-friendly park, and amenities like a linen closet and handy walk-up access. Whether you're a student or a professional, our community makes comfortable living easily accessible.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
      "featured_image_media": {
        "alt_text": "Stone Throw community sign with windmill and clubhouse in background.",
        "public_id": "019d02cf-0015-745f-8329-5657ae2904ba",
        "storage_key": "property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
        "width": 1037,
        "height": 691
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Northwest Nazarene University",
      "seo_description": "Cottages at Stonesthrow offers comfort and convenience near Northwest Nazarene University. Spacious interiors and great amenities await.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "generator",
      "page_item_url": "apartments-near-terry-reilly-health-services-meridian",
      "search_query": "apartments near Terry Reilly Health Services Meridian in Ada County",
      "category": "Hospital",
      "h1_title": "Convenient Living Near Terry Reilly Health",
      "h2_subtitle": "Discover comfortable apartments near Terry Reilly Health Services in Meridian. Cottages at Stonesthrow offers modern living with a host of amenities.",
      "page_copy": "If you're seeking apartments near Terry Reilly Health Services in Meridian, look no further than Cottages at Stonesthrow. Located in Ada County, our community offers spacious two- and three-bedroom apartments designed to enhance your lifestyle. With features like vaulted ceilings and hardwood floors, enjoy living spaces that are both stylish and practical.\n\nIn addition to being conveniently located near Terry Reilly Health Services, Cottages at Stonesthrow boasts a variety of community amenities. Residents can enjoy access to a delightful clubhouse, an on-site dog park, and the convenience of door-to-door trash pickup. Whether you work at the health services or just value proximity, our community offers the perfect blend of convenience and comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
      "featured_image_media": {
        "alt_text": "Stone Throw community sign with windmill and clubhouse in background.",
        "public_id": "019d02cf-0015-745f-8329-5657ae2904ba",
        "storage_key": "property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
        "width": 1037,
        "height": 691
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Terry Reilly Health Services",
      "seo_description": "Cottages at Stonesthrow, located in Ada County, offers premium apartments near Terry Reilly Health Services with modern amenities and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "generator",
      "page_item_url": "apartments-near-julius-kleiner-memorial-park-meridian",
      "search_query": "apartments near Julius M. Kleiner Memorial Park Meridian",
      "category": "Park",
      "h1_title": "Live Close to Julius M. Kleiner Park",
      "h2_subtitle": "Find apartments near Julius M. Kleiner Memorial Park in Meridian at Cottages at Stonesthrow. Enjoy a convenient, vibrant community with engaging amenities.",
      "page_copy": "Searching for apartments near the scenic Julius M. Kleiner Memorial Park in Meridian? Cottages at Stonesthrow offers the ideal location with roomy two- and three-bedroom options featuring vaulted ceilings and elegant hardwood floors. This beautifully designed community combines comfort with convenience, creating an inviting atmosphere.\n\nSituated just minutes from Julius M. Kleiner Memorial Park, our residents enjoy the benefits of a nearby green space and a host of on-site amenities. Whether it's socializing in our clubhouse or walking your furry friend in the dog park, Cottages at Stonesthrow offers an enriching experience. Enjoy modern conveniences like walk-up access and easy door-to-door trash pickup in this vibrant community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
      "featured_image_media": {
        "alt_text": "Stone Throw community sign with windmill and clubhouse in background.",
        "public_id": "019d02cf-0015-745f-8329-5657ae2904ba",
        "storage_key": "property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
        "width": 1037,
        "height": 691
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Julius M. Kleiner Park",
      "seo_description": "Explore Cottages at Stonesthrow, your perfect home near Julius M. Kleiner Memorial Park. Enjoy scenic views and modern, comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "generator",
      "page_item_url": "meridian-rentals-close-to-discovery-park",
      "search_query": "Meridian rentals close to Discovery Park",
      "category": "Park",
      "h1_title": "Meridian Rentals Near Discovery Park",
      "h2_subtitle": "Explore Meridian rentals close to Discovery Park at Cottages at Stonesthrow. Enjoy a selection of modern amenities and comfortable living spaces.",
      "page_copy": "For those seeking Meridian rentals close to Discovery Park, look no further than Cottages at Stonesthrow. Offering spacious two- and three-bedroom layouts, our community provides a tranquil retreat with features like vaulted ceilings and elegant hardwood floors. Situated near one of the area's beloved green spaces, residents enjoy both convenience and beauty.\n\nThe proximity to Discovery Park enriches outdoor recreation options, while our on-site amenities enhance daily life. Indulge in the welcoming ambiance of our clubhouse or bond with your pet at the dog park. With convenient door-to-door trash pickup and walk-up access, Cottages at Stonesthrow ensures your living experience is both seamless and enjoyable.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
      "featured_image_media": {
        "alt_text": "Stone Throw community sign with windmill and clubhouse in background.",
        "public_id": "019d02cf-0015-745f-8329-5657ae2904ba",
        "storage_key": "property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
        "width": 1037,
        "height": 691
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Meridian Rentals Near Discovery Park",
      "seo_description": "Discover Cottages at Stonesthrow, offering Meridian rentals near Discovery Park. Enjoy spacious living areas and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "generator",
      "page_item_url": "apartments-by-settlers-park-ada-county",
      "search_query": "apartments by Settlers' Park in Ada County",
      "category": "Park",
      "h1_title": "Apartments Close to Settlers' Park",
      "h2_subtitle": "Find apartments by Settlers' Park in Ada County at Cottages at Stonesthrow. Experience a perfect blend of convenience and modern living.",
      "page_copy": "If you’re in search of apartments by Settlers' Park in Ada County, Cottages at Stonesthrow is the place to be. Our spacious two- and three-bedroom floor plans boast features such as vaulted ceilings and beautiful hardwood floors. Conveniently located near the popular Settlers' Park, our community offers easy access to outdoor fun and relaxation.\n\nBeyond location, Cottages at Stonesthrow provides amenities designed to elevate your lifestyle. Residents can enjoy social gatherings in the clubhouse, take care of daily chores with door-to-door trash pickup, and let their pets roam free in the on-site dog park. Experience comfortable living in a vibrant community just steps away from Settlers' Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
      "featured_image_media": {
        "alt_text": "Stone Throw community sign with windmill and clubhouse in background.",
        "public_id": "019d02cf-0015-745f-8329-5657ae2904ba",
        "storage_key": "property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
        "width": 1037,
        "height": 691
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Settlers' Park, Ada County",
      "seo_description": "Live at Cottages at Stonesthrow, offering modern apartments by Settlers' Park in Ada County with spacious layouts and community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "generator",
      "page_item_url": "apartments-near-storey-park-meridian-id",
      "search_query": "apartments near Storey Park Meridian ID",
      "category": "Park",
      "h1_title": "Live Near Storey Park in Meridian",
      "h2_subtitle": "Explore apartments near Storey Park, Meridian ID, at Cottages at Stonesthrow. Experience modern amenities and spacious living.",
      "page_copy": "Looking for apartments near Storey Park in Meridian, ID? Cottages at Stonesthrow offers the perfect combination of comfort and convenience. Our expansive two- and three-bedroom units feature vaulted ceilings and sophisticated hardwood floors, creating an ideal living environment near the tranquility of Storey Park.\n\nBeyond beautifully designed interiors, our community is equipped with amenities to enhance your lifestyle. From the inviting clubhouse to a dog park for your four-legged friends, everything you need is within reach. Our convenient location near Storey Park ensures that nature and activities are always just moments away. Come experience seamless living in the heart of Meridian.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
      "featured_image_media": {
        "alt_text": "Stone Throw community sign with windmill and clubhouse in background.",
        "public_id": "019d02cf-0015-745f-8329-5657ae2904ba",
        "storage_key": "property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
        "width": 1037,
        "height": 691
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Storey Park, Meridian ID",
      "seo_description": "Discover Cottages at Stonesthrow, premium apartments near Storey Park, Meridian ID. Enjoy spacious living and community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "generator",
      "page_item_url": "meridian-id-living-near-storey-bark-park",
      "search_query": "Meridian ID living near Storey Bark Park",
      "category": "Park",
      "h1_title": "Living Near Storey Bark Park in Meridian",
      "h2_subtitle": "Discover Meridian ID living near Storey Bark Park at Cottages at Stonesthrow. Enjoy a vibrant community with pet-friendly amenities.",
      "page_copy": "Experience the best of Meridian ID living near Storey Bark Park at Cottages at Stonesthrow. Our community offers spacious two- and three-bedroom apartments, complete with vaulted ceilings and elegant hardwood floors. Being close to Storey Bark Park, pet owners can delight in walking their furry friends conveniently.\n\nApart from proximity to the Bark Park, Cottages at Stonesthrow is designed with pet-friendly living in mind. Residents benefit from a dedicated dog park on-site, a welcoming clubhouse for gatherings, and hassle-free door-to-door trash services. Embrace comfort and convenience in a community tailored for both you and your pets, right in Meridian.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
      "featured_image_media": {
        "alt_text": "Stone Throw community sign with windmill and clubhouse in background.",
        "public_id": "019d02cf-0015-745f-8329-5657ae2904ba",
        "storage_key": "property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
        "width": 1037,
        "height": 691
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Meridian ID Living Near Storey Bark Park",
      "seo_description": "Live at Cottages at Stonesthrow, Meridian ID living near Storey Bark Park. Enjoy a pet-friendly community with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "generator",
      "page_item_url": "close-to-home-accommodations-near-tully-park-83642",
      "search_query": "close-to-home accommodations near Tully Park 83642",
      "category": "Park",
      "h1_title": "Accommodations Near Tully Park, Meridian",
      "h2_subtitle": "Discover close-to-home accommodations near Tully Park, 83642, at Cottages at Stonesthrow. Enjoy spacious living in a friendly community.",
      "page_copy": "For those seeking close-to-home accommodations near Tully Park in the 83642 area, Cottages at Stonesthrow offers the perfect solution. Located just a short distance from Tully Park, our two- and three-bedroom apartments provide ample space with features such as vaulted ceilings and stunning hardwood floors, creating a comforting and inviting atmosphere.\n\nOur community is designed with convenience and enjoyment in mind. Residents of Cottages at Stonesthrow can take advantage of amenities like a clubhouse ideal for social gatherings, an on-site dog park, and efficient door-to-door trash service. Enjoy the benefits of proximity to Tully Park while living in a vibrant and accommodating community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
      "featured_image_media": {
        "alt_text": "Stone Throw community sign with windmill and clubhouse in background.",
        "public_id": "019d02cf-0015-745f-8329-5657ae2904ba",
        "storage_key": "property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
        "width": 1037,
        "height": 691
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Accommodations Near Tully Park, Meridian 83642",
      "seo_description": "Enjoy close-to-home accommodations near Tully Park, 83642 at Cottages at Stonesthrow. Spacious apartments and a friendly community await.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "generator",
      "page_item_url": "fuller-park-adjacent-apartments-meridian",
      "search_query": "Fuller Park adjacent apartments in Meridian",
      "category": "Park",
      "h1_title": "Fuller Park Adjacent Apartments",
      "h2_subtitle": "Discover apartments adjacent to Fuller Park in Meridian at Cottages at Stonesthrow. Experience a blend of comfort and convenience.",
      "page_copy": "If you're seeking apartments adjacent to Fuller Park in Meridian, Cottages at Stonesthrow offers an unrivaled location that combines comfort and accessibility. Our community boasts spacious two- and three-bedroom apartments featuring vaulted ceilings and refined hardwood floors, perfect for those who want a touch of elegance in their living space.\n\nCottages at Stonesthrow not only provides proximity to the lush landscapes of Fuller Park but also includes numerous amenities designed to enhance your lifestyle. From a community clubhouse that serves as a social hub to a dog park for your furry companions, we ensure all residents enjoy a comprehensive living experience. Join our vibrant community for the perfect blend of park-side tranquility and luxury living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
      "featured_image_media": {
        "alt_text": "Stone Throw community sign with windmill and clubhouse in background.",
        "public_id": "019d02cf-0015-745f-8329-5657ae2904ba",
        "storage_key": "property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
        "width": 1037,
        "height": 691
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fuller Park Adjacent Apartments in Meridian",
      "seo_description": "Find Fuller Park adjacent apartments in Meridian at Cottages at Stonesthrow. Enjoy spacious living with great amenities close to parks.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "generator",
      "page_item_url": "residences-near-keith-bird-legacy-park-west-boise",
      "search_query": "residences near Keith Bird Legacy Park West Boise",
      "category": "Park",
      "h1_title": "Residences Near Keith Bird Legacy Park",
      "h2_subtitle": "Explore residences near Keith Bird Legacy Park in West Boise at Cottages at Stonesthrow. Enjoy a vibrant community with fantastic amenities.",
      "page_copy": "Located near Keith Bird Legacy Park, Cottages at Stonesthrow offers exceptional residences in the West Boise area. Our spacious two- and three-bedroom apartments are designed with modern amenities like vaulted ceilings and beautiful hardwood floors, perfect for those seeking comfort and style.\n\nBeyond the appealing interiors, our community offers excellent amenities that enhance your lifestyle. Residents enjoy access to a welcoming clubhouse, a convenient on-site dog park, and efficient door-to-door trash pickup. Being close to Keith Bird Legacy Park, you’ll have ample opportunities for outdoor activities while enjoying the vibrant community spirit at Cottages at Stonesthrow.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
      "featured_image_media": {
        "alt_text": "Stone Throw community sign with windmill and clubhouse in background.",
        "public_id": "019d02cf-0015-745f-8329-5657ae2904ba",
        "storage_key": "property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
        "width": 1037,
        "height": 691
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Residences Near Keith Bird Legacy Park, Boise",
      "seo_description": "Discover residences near Keith Bird Legacy Park in West Boise at Cottages at Stonesthrow. Enjoy modern living with great amenities and park proximity.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166559",
      "source": "generator",
      "page_item_url": "bernadine-quinn-park-accessible-apartments-meridian",
      "search_query": "Bernadine Quinn Park accessible apartments Meridian",
      "category": "Park",
      "h1_title": "Apartments Near Bernadine Quinn Park",
      "h2_subtitle": "Find accessible apartments near Bernadine Quinn Park in Meridian at Cottages at Stonesthrow. Experience comfort and connectivity.",
      "page_copy": "Discover accessible apartment living near Bernadine Quinn Park in Meridian at the inviting Cottages at Stonesthrow. Our spacious two- and three-bedroom units offer modern features like vaulted ceilings and attractive hardwood floors, creating a warm and inviting atmosphere perfect for relaxation and entertainment.\n\nIn addition to our impressive apartment features, residents will benefit from amenities that complement a convenient lifestyle. A welcoming clubhouse offers a space for social connections, while our on-site dog park accommodates your furry friends. With close proximity to Bernadine Quinn Park, you can enjoy beautiful outdoor environments while residing in a vibrant community at Cottages at Stonesthrow.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
      "featured_image_media": {
        "alt_text": "Stone Throw community sign with windmill and clubhouse in background.",
        "public_id": "019d02cf-0015-745f-8329-5657ae2904ba",
        "storage_key": "property/6767906449166559/019d02cf-0015-745f-8329-5657ae2904ba.webp",
        "width": 1037,
        "height": 691
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Bernadine Quinn Park, Meridian",
      "seo_description": "Explore accessible apartments near Bernadine Quinn Park in Meridian at Cottages at Stonesthrow. Spacious living with modern amenities and park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5346"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18077021013"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PGZBKD5X"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 3"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Preferred"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "596ST2"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "39895424274"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImpWWE1pSGZHa2t2dTRZRmNSR1d4bkE9PSIsInZhbHVlIjoiVFpkWXdsVEhhUzNTNzA2TDFmaEdDUT09IiwibWFjIjoiYmEzODQzMjI1ODRiMzIzM2I4YTRiYzkzMzYzZWRlMTQwOWQ0YTI1ZDY5MWQzMmFmNGYyYTZmMDIxMTc4MzM3ZSJ9"
    }
  ],
  "custom_qb_id": "5346",
  "custom_repli_id": "18077021013",
  "custom_google_gtm_id": "GTM-PGZBKD5X",
  "custom_rollout_phase": "Phase 3",
  "custom_vibesites_theme": "Preferred",
  "custom_aim_property_code": "596ST2",
  "custom_hubspot_company_id": "39895424274",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImpWWE1pSGZHa2t2dTRZRmNSR1d4bkE9PSIsInZhbHVlIjoiVFpkWXdsVEhhUzNTNzA2TDFmaEdDUT09IiwibWFjIjoiYmEzODQzMjI1ODRiMzIzM2I4YTRiYzkzMzYzZWRlMTQwOWQ0YTI1ZDY5MWQzMmFmNGYyYTZmMDIxMTc4MzM3ZSJ9",
  "custom_audioeye_site_id": "3047a401-22e8-4ad4-9a60-16abde235f2e",
  "custom_audioeye_site_hash": "3e9fca6e4c13bf5500d526ef08045442"
};

export const generatedAt = '2026-10-05T17:25:40.204Z';
